<template>
  <el-container class="clues">

    <el-header class="header-style">
      <el-row :span="24">
        <div class="top_hint">
          <i class="iconfont"></i>
          <span class="count">您已领取线索 {{ user_thread_number }} 条，当日未沟通
            <span style="color: red">{{ today_communicat }}</span> 条， 当日二次咨询
            <span style="color: red">{{ repeat_count }}</span>
            条，请及时与客户沟通！否则企业火线索将于3日后，火山线索将于30日后流入线索公海</span>
        </div>
      </el-row>
      <el-divider content-position="left">我的线索</el-divider>
      <el-row>
        <el-col :span="6" class="search_position">
          <el-input prefix-icon="el-icon-search search" v-model="search" size="mini" clearable filterable placeholder="输入客户姓名或手机号/线索编码搜索" />
        </el-col>
        <el-col :span="18" class="tr" v-if="pageNodes.indexOf('转让线索') !== -1">
          <el-button type="primary" size="mini" @click="handleAddAllot">转让线索</el-button>
        </el-col>
      </el-row>
      <el-collapse @change="handleChangeHeight" v-model="activeOpen" accordion>
        <el-collapse-item title="高级筛选" name="1">
          <div class="changeHeight m-tabs-content">
            <el-row>
              <el-col :span="2" class="tr m-label text_right">线索状态</el-col>
              <el-col :span="4">
                <el-select multiple collapse-tags v-model="highSearch.status" placeholder="请选择线索状态" size="mini"
                  clearable>
                  <el-option :value="1" label="跟踪中"></el-option>
                  <el-option :value="4" label="成单待确认"></el-option>
                  <el-option :value="3" label="无法联系"></el-option>
                  <el-option :value="2" label="已成交"></el-option>
                </el-select>
              </el-col>
              <el-col :span="2" :offset="3" class="tr m-label text_right">群聊ID</el-col>
              <el-col :span="4">
                <el-input @change="groupInput" v-model="highSearch.group_chat_id" size="mini" placeholder="输入群聊ID" />
              </el-col>
              <el-col :span="2" :offset="3" class="tr m-label text_right">咨询分类</el-col>
              <el-col :span="4">
                <el-select :filterable="true" multiple collapse-tags v-model="highSearch.refer_cate"
                  placeholder="请选择咨询分类" size="mini" clearable>
                  <el-option v-for="item in serverTypes" :key="item.server_id" :label="item.server_name"
                    :value="item.server_id">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="2" class="tr m-label text_right">录入时间</el-col>
              <el-col :span="4">
                <div>
                  <el-date-picker v-model="value1" type="daterange" range-separator="至" size="mini"
                    format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" @change="pickerDataChange"
                    start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
                  </el-date-picker>
                </div>
              </el-col>
              <el-col :span="2" :offset="3" class="tr m-label text_right">客户意向</el-col>
              <el-col :span="4">
                <el-select multiple collapse-tags v-model="highSearch.intention" placeholder="请选择客户意向" size="mini"
                  clearable>
                  <el-option :value="1" label="A"></el-option>
                  <el-option :value="2" label="B"></el-option>
                  <el-option :value="3" label="C"></el-option>
                  <el-option :value="4" label="D"></el-option>
                  <el-option :value="5" label="E"></el-option>
                </el-select>
              </el-col>
              <el-col :span="2" :offset="3" class="tr m-label text_right">选择园区</el-col>
              <el-col :span="4">
                <el-select multiple collapse-tags v-model="highSearch.garden" placeholder="请选择园区" size="mini" clearable>
                  <el-option :value="1" label="上海园区"></el-option>
                  <el-option :value="2" label="南京园区"></el-option>
                  <el-option :value="3" label="徐州园区"></el-option>
                  <el-option :value="6" label="北京园区"></el-option>
                  <el-option :value="7" label="天津园区"></el-option>
                  <el-option :value="8" label="江苏园区"></el-option>
                  <el-option :value="9" label="浙江园区"></el-option>
                  <el-option :value="10" label="广东园区"></el-option>
                  <el-option :value="11" label="江西园区"></el-option>
                  <el-option :value="12" label="山东园区"></el-option>
                  <el-option :value="13" label="山西园区"></el-option>
                  <el-option :value="14" label="河南园区"></el-option>
                  <el-option :value="15" label="河北园区"></el-option>
                  <el-option :value="16" label="湖南园区"></el-option>
                  <el-option :value="17" label="湖北园区"></el-option>
                  <el-option :value="18" label="贵州园区"></el-option>
                  <el-option :value="19" label="陕西园区"></el-option>
                  <el-option :value="20" label="四川园区"></el-option>
                  <el-option :value="21" label="安徽园区"></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="2" class="tr m-label text_right">所属省市</el-col>
              <el-col :span="4">
                <el-cascader ref="cascaderAddr" placeholder="请选择城市" v-model="value3" filterable :props="optionProps"
                  :options="options" size="mini" @change="handleChangeSearch"
                  :filter-method="filterOptions"></el-cascader>
              </el-col>
              <el-col :span="6" :offset="3">
                <el-switch style="height: 0.56rem" v-model="value5" :width="40" @change="switchChange"
                  active-text="排除所选城市">
                </el-switch>
              </el-col>
              <el-col :span="6" :offset="3">
                <el-switch style="height: 0.56rem" v-model="relation" :width="40" @change="switchChange2"
                  active-text="是否联系">
                </el-switch>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="2" class="tr m-label text_right">最近联系时间</el-col>
              <el-col :span="4">
                <div>
                  <el-date-picker v-model="highSearch.communicat_at" type="daterange" range-separator="至" size="mini"
                    format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" @change="pickerDataChangeRecently"
                    start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptionsContact">
                  </el-date-picker>
                </div>
              </el-col>
              <el-col :span="2" :offset="3" class="m-label">客户性格</el-col>
              <el-col :span="4" class="m-label">
                <el-select multiple collapse-tags :filterable="true" v-model="highSearch.custom_trait"
                  placeholder="请选择客户性格" size="mini" clearable>
                  <el-option v-for="item in clientCharacter" :key="item.id" :label="item.title" :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="2" :offset="3" class="m-label">客户性别</el-col>
              <el-col :span="4">
                <el-select v-model="highSearch.custom_sex" placeholder="请选择" size="mini" clearable>
                  <el-option :value="1" label="未知"></el-option>
                  <el-option :value="2" label="男"></el-option>
                  <el-option :value="3" label="女"></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="2" class="m-label" style="display: flex">客户类型</el-col>
              <el-col :span="4" class="m-label">
                <el-select :filterable="true" multiple collapse-tags v-model="highSearch.custom_type"
                  placeholder="请选择客户类型" size="mini" clearable>
                  <el-option v-for="item in clientType" :key="item.id" :label="item.title" :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="2" :offset="3" class="m-label">主营行业</el-col>
              <el-col :span="4">
                <el-select :filterable="true" multiple collapse-tags v-model="highSearch.custom_industry"
                  placeholder="请选择主营行业" size="mini" clearable>
                  <el-option v-for="item in industry" :key="item.industry_id" :label="item.industry_name"
                    :value="item.industry_id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="2" :offset="3" class="m-label">是否会员</el-col>
              <el-col :span="4">
                <el-radio-group v-model="highSearch.is_member" size="mini">
                  <el-radio-button label="y">是</el-radio-button>
                  <el-radio-button label="n">否</el-radio-button>
                  <el-radio-button label="pn">号码为空</el-radio-button>
                </el-radio-group>
              </el-col>
              <!-- <el-col :span="2" :offset="3" class="m-label">年营业额</el-col>
            <el-col :span="4">
              <el-select
                :filterable="true"
                multiple
                collapse-tags
                v-model="highSearch.custom_turnover"
                placeholder="请选择年营业额"
                size="mini"
                clearable
              >
                <el-option
                  v-for="item in clientCompanyTurnover"
                  :key="item.id"
                  :label="item.title"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-col> -->
            </el-row>
            <el-row>
              <el-col :span="2" class="m-label">员工数量：</el-col>
              <el-col :span="4">
                <el-select :filterable="true" multiple collapse-tags v-model="highSearch.custom_staff"
                  placeholder="请选择员工数量" size="mini" clearable>
                  <el-option v-for="item in clientCompanyStaffNum" :key="item.id" :label="item.title" :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="6" :offset="3">
                <el-switch style="height: 0.56rem" v-model="value6" :width="40" @change="switchChangeTS"
                  active-text="是否是特殊行业">
                </el-switch>
              </el-col>
              <el-col :span="2" :offset="3" class="m-label">许可证</el-col>
              <el-col :span="4">
                <el-select :filterable="true" multiple collapse-tags v-model="highSearch.license" placeholder="请选择许可证"
                  size="mini" clearable>
                  <el-option v-for="item in licenseData" :key="item.license_id" :label="item.license_name"
                    :value="item.license_id">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="2" class="m-label">客户套餐需求</el-col>
              <el-col :span="4">
                <el-select :filterable="true" multiple collapse-tags v-model="highSearch.need_combo"
                  placeholder="请选择客户套餐需求" size="mini" clearable>
                  <el-option v-for="item in combo" :key="item.combo_id" :label="item.combo_name" :value="item.combo_id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="2" :offset="3" class="m-label">
                <el-tooltip content="客户可能需要的服务" placement="top">
                  <span class="count_style" style="display: inherit">客户可能需要的服务</span>
                </el-tooltip>
              </el-col>
              <el-col :span="4">
                <el-select :filterable="true" multiple collapse-tags v-model="highSearch.maybe_need_server"
                  placeholder="请选择客户可能需要的服务" size="mini" clearable>
                  <el-option v-for="item in SelectItem" :key="item.item_id" :label="item.item_name"
                    :value="item.item_id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="2" :offset="3" class="m-label">客户来源</el-col>
              <el-col :span="4">
                <el-select :filterable="true" multiple collapse-tags v-model="highSearch.custom_source"
                  placeholder="请选择客户来源" size="mini" clearable>
                  <el-option v-for="item in customSource" :key="item.source_id" :label="item.source_name"
                    :value="item.source_id">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-switch style="height: 0.56rem" v-model="value7" :width="40" @change="switchChangeClues"
                  active-text="线索超过80分">
                </el-switch>
              </el-col>
              <el-col :span="6" :offset="3">
                <el-switch style="height: 0.56rem" v-model="value8" :width="40" @change="switchChangeIsAddWx"
                  active-text="是否添加微信">
                </el-switch>
              </el-col>
              <el-col :span="2" :offset="3" class="tr m-label text_right">领取时间</el-col>
              <el-col :span="4">
                <div>
                  <el-date-picker v-model="highSearch.get_thread_at" type="daterange" range-separator="至" size="mini"
                    format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" @change="pickerDataTimeChange"
                    start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
                  </el-date-picker>
                </div>
              </el-col>
            </el-row>
            <el-row style="text-align: center;">
              <el-col :span="24">
                <el-button type="primary" size="mini" @click="handleSearch">查询</el-button>
                <el-button type="danger" size="mini" @click="handleCloseSearch">清除</el-button>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
        <el-collapse-item title="数据统计" name="2">
          <el-row class="mb-10">
            <el-col :span="3" style="display: flex">
              <div class="level count_style">
                <span class="count" style="color: #5787ff">客户意向：</span>
                <i class="el-icon-question" @click="dialogVisible3 = true"></i>
              </div>
            </el-col>
            <el-col :span="16" style="display: flex">
              <div class="level_num count_style">
                <span class="count" style="display: inline-block; width: 2rem; margin-left: 0.4rem">A：{{ intentionData.A
                  }}</span>
                <span class="count" style="display: inline-block; width: 2rem; margin-left: 0.4rem">B：{{ intentionData.B
                  }}</span>
                <span class="count" style="display: inline-block; width: 2rem; margin-left: 0.4rem">C：{{ intentionData.C
                  }}</span>
                <span class="count" style="display: inline-block; width: 2rem; margin-left: 0.4rem">D：{{ intentionData.D
                  }}</span>
                <span class="count" style="display: inline-block; width: 2rem; margin-left: 0.4rem">E：{{ intentionData.E
                  }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row class="mb-10">
            <el-col :span="3" style="display: flex">
              <div class="level count_style">
                <span class="count" style="color: #5787ff">等级：</span>
                <img :src="img" alt="" />
                <span class="count">{{ vipName }}</span>
                <i class="el-icon-question" @click="dialogVisible2 = true"></i>
              </div>
            </el-col>
            <el-col :span="16" style="display: flex">
              <div class="level_num count_style">
                <span class="count" style="display: inline-block; width: 2rem; margin-left: 0.4rem">IM套电：{{
        vipData.user_thread_row }}</span>
                <span class="count" style="display: inline-block; width: 2rem; margin-left: 0.4rem">今日领取：{{
        vipData.today_get }}</span>
                <span class="count" style="display: inline-block; width: 2rem; margin-left: 0.4rem">今日联系：{{
        vipData.today_communicat }}</span>
                <span class="count" style="display: inline-block; width: 2rem; margin-left: 0.4rem">今日转化：{{
        vipData.today_success }}</span>
                <span class="count" style="display: inline-block; width: 2rem; margin-left: 0.4rem">今日放弃：{{
        vipData.today_giveup }}</span>
                <span class="count" style="display: inline-block; width: 2rem; margin-left: 0.4rem">日均转化率：{{
        vipData.percentage }}</span>
              </div>
            </el-col>
          </el-row>
          <!-- <el-row class="mb-10">
        <el-col :span="3" style="display: flex">
          <div class="level count_style">
            <span class="count" style="color: #5787FF"></span>
          </div>
        </el-col>
        <el-col :span="15" style="display: flex">
          <div class="level_num count_style" >
            <span class="count"  style="display: inline-block;  margin-left: .4rem">非今日领取联系：{{NVipData.person_not_today_communicat}}</span>
            <span class="count"  style="display: inline-block;  margin-left: .4rem">非今日领取转化：{{NVipData.person_not_today_get_success}}</span>
            <span class="count"  style="display: inline-block;  margin-left: .4rem">今日领取联系通话时长：{{vipData.today_duration}}</span>
            <span class="count"  style="display: inline-block;  margin-left: .4rem">今日领取联系平均通话时长：{{vipData.today_avg_duration}}</span>
          </div>
        </el-col>
        <el-col :span="4" class="search_position"></el-col>
      </el-row> -->
          <!-- <el-row class="mb-10">
        <el-col :span="3" style="display: flex">
          <div class="level count_style">
            <span class="count" style="color: #5787FF"></span>
          </div>
        </el-col>
        <el-col :span="15" style="display: flex">
          <div class="level_num count_style" >
            <span class="count"  style="display: inline-block;  margin-left: .4rem">今日领取未联系：{{vipData.today_never_communicat}}</span>
          </div>
        </el-col>
        <el-col :span="4" class="search_position"></el-col>
      </el-row> -->
          <el-row class="mb-10">
            <el-col :span="3" style="display: flex">
              <div class="level count_style" style="margin-right: 0.38rem">
                <span class="count" style="color: #5787ff">仓位：{{ vipData.user_thread_row }}/<span>{{
        vipData.store_space
      }}</span></span>
              </div>
            </el-col>
            <el-col :span="21" style="display: flex">
              <div class="level_num count_style">
                <span class="count" style="display: inline-block; width: 2rem; margin-left: 0.4rem">公司分配：{{
        company_allot.allot_thread_row }}</span>
                <span class="count" style="display: inline-block; width: 2rem; margin-left: 0.4rem">今日分配：{{
        company_allot.allot_get }}</span>
                <span class="count" style="display: inline-block; width: 2rem; margin-left: 0.4rem">今日联系：{{
        company_allot.allot_communicat }}</span>
                <span class="count" style="display: inline-block; width: 2rem; margin-left: 0.4rem">今日转化：{{
        company_allot.allot_success }}</span>
                <span class="count" style="display: inline-block; width: 2rem; margin-left: 0.4rem">今日放弃：{{
        company_allot.allot_giveup }}</span>
                <span class="count" style="display: inline-block; width: 2rem; margin-left: 0.4rem">日均转化率：{{
        company_allot.percentage }}</span>
              </div>
            </el-col>
          </el-row>
          <!-- <el-row class="mb-10">
        <el-col :span="3" style="display: flex">
          <div class="level count_style">
            <span class="count" style="color: #5787FF"></span>
          </div>
        </el-col>
        <el-col :span="15" style="display: flex">
          <div class="level_num count_style" >
            <span class="count"  style="display: inline-block;  margin-left: .4rem">非今日分配联系：{{NVipData.allot_not_today_communicat}}</span>
            <span class="count"  style="display: inline-block;  margin-left: .4rem">非今日分配转化：{{NVipData.allot_not_today_get_success}}</span>
            <span class="count"  style="display: inline-block;  margin-left: .4rem">今日分配联系通话时长：{{company_allot.allot_duration}}</span>
            <span class="count"  style="display: inline-block;  margin-left: .4rem">今日分配联系平均通话时长：{{company_allot.allot_avg_duration}}</span>
          </div>
        </el-col>
        <el-col :span="4" class="search_position"></el-col>
      </el-row> -->
          <!-- <el-row class="mb-10"> -->
          <!-- <el-col :span="3" style="display: flex">
          <div class="level count_style">
            <span class="count" style="color: #5787FF"></span>
          </div>
        </el-col> -->
          <!-- <el-col :span="15" style="display: flex">
          <div class="level_num count_style">
            <span class="count"  style="display: inline-block;  margin-left: .4rem">今日分配未联系：{{company_allot.today_never_communicat}}</span>
          </div>
        </el-col> -->

          <!-- </el-row> -->
        </el-collapse-item>
      </el-collapse>

    </el-header>

    <el-main class="main-style">
      <el-table height="calc(100vh - 366px)" :data="pageData" size="medium" :row-class-name="tableRowClassName"
        v-if="!loading" style="width: 100%" @selection-change="handleSelectionChange" border>
        <el-table-column v-if="pageNodes.indexOf('转让线索') !== -1" type="selection" width="55" fixed></el-table-column>
        <el-table-column fixed label="" width="30" prop="is_suggest" v-if="false">
          <template slot-scope="scope">
            <i v-if="scope.row.is_suggest !== 0" class="el-icon-chat-dot-square"></i>
          </template>
        </el-table-column>
        <el-table-column v-if="true" fixed label="线索编码" width="150" prop="tag_code">
          <template slot-scope="scope">
            <div :style="scope.row.status !== 2 ? 'cursor: pointer;width: 100%' : ''">
              <span @click="copyUrl(scope.row.tag_code)" class="dot"
                style="margin-right: 0.1rem; display: inline-block; width: 65%">
                <i v-if="scope.row.is_suggest !== 0" class="el-icon-chat-dot-square"></i>
                {{ scope.row.tag_code }}
              </span>
              <i @click="handleSignStar(scope.$index, scope.row)" v-if="scope.row.status !== 2" class="el-icon-star-on"
                :style="{ color: scope.row.sign_at ? 'red' : '' }"></i>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="客户姓名" fixed width="80">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.custom_name + ''" placement="top">
              <span class="count_style" style="display: inherit">{{
        scope.row.custom_name
      }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="客户手机" fixed width="175">
          <template slot-scope="scope">
            <!-- <el-tooltip
              :content="scope.row.custom_phone + ''"
              placement="top"
              style="display: inline-block; vertical-align: middle"
            > -->
            <!-- <span @click="call2(scope.$index, scope.row)" class="count_style" style="display: inherit; cursor: pointer;"><i style="color: rgb(87, 135, 255)" class="el-icon-mobile-phone"></i><el-link style="color: #409EFF;cursor: pointer" @click.stop="openPhoneFromDraw(scope.row.custom_phone)">{{scope.row.custom_phone.substring(0,5) + '...'}}</el-link></span> -->
            <!-- <span
                @click="call2(scope.$index, scope.row)"
                class="count_style"
                style="display: inherit; cursor: pointer"
                ><el-link
                  style="color: #409eff; cursor: pointer"
                  @click.stop="openPhoneFromDraw(scope.row.custom_phone)"
                  >{{
                    scope.row.custom_phone
                      ? scope.row.custom_phone.substring(0, 5) + "..."
                      : ""
                  }}</el-link
                ></span >-->
            
            <!--             <span @click="lineNum === '1' ? call(scope.row.custom_phone, scope.$index, scope.row) : call2(scope.$index, scope.row)" class="count_style" style="display: inherit; cursor: pointer;"><i :style="lineNum === '1' ? 'color: #67C23A' : 'color: rgb(87, 135, 255)'" class="el-icon-mobile-phone"></i>{{scope.row.custom_phone}}</span> -->
            <!-- </el-tooltip> -->
            <phone-com :comPhone="scope.row.custom_phone" :vagaryPhone="scope.row.vagary_phone"
              style="display: inline-block;" />
            <el-tooltip effect="drak" content="电话外呼" placement="bottom"
              style="display: inline-block; vertical-align: middle">
              <i @click="call2(scope.$index, scope.row)" class="el-icon-phone-outline"
                style="color: #409eff; cursor: pointer"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column class="el-status" fixed label="线索状态" prop="status" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.status !== 2" class="popover_span">
              <span class="el-position" :style="{ color: scope.row.status === 2 ? '#CCCCCC' : '' }">
                <span class="dot" :style="{
        background:
          scope.row.status === 1
            ? '#88D023'
            : '' || scope.row.status === 2
              ? '#CCCCCC'
              : '' || scope.row.status === 3
                ? '#D02323'
                : '' || scope.row.status === 4
                  ? '#FDB526'
                  : '',
      }"></span>
                {{
        scope.row.status == 1
          ? "跟踪中"
          : "" || scope.row.status == 2
            ? "已成交"
            : "" || scope.row.status == 3
              ? "无法联系"
              : "" || scope.row.status == 4
                ? "成单待确认"
                : ""
      }}</span>
            </div>
            <el-popover v-if="scope.row.status === 2" placement="right" trigger="hover" width="280">
              <div class="popoverList">
                <span style="margin-right: 0.2rem">派单时间：{{
        scope.row.order_date ? scope.row.order_date : "无"
      }}</span>
                <span>转化天数：{{ scope.row.convert_days }}</span>
              </div>
              <el-button style="padding: 0; border: 0" slot="reference">
                <div class="popover_span" :style="{ cursor: scope.row.status === 2 ? 'pointer' : '' }">
                  <span class="el-position" :style="{ color: scope.row.status === 2 ? '#CCCCCC' : '' }">
                    <span class="dot" :style="{
        background:
          scope.row.status === 1
            ? '#88D023'
            : '' || scope.row.status === 2
              ? '#CCCCCC'
              : '' || scope.row.status === 3
                ? '#D02323'
                : '' || scope.row.status === 4
                  ? '#FDB526'
                  : '',
      }"></span>
                    {{
        scope.row.status == 1
          ? "跟踪中"
          : "" || scope.row.status == 2
            ? "已成交"
            : "" || scope.row.status == 3
              ? "无法联系"
              : "" || scope.row.status == 4
                ? "成单待确认"
                : ""
      }}</span>
                </div>
              </el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column fixed label="线索分数" width="80" prop="thread_score">
          <template slot-scope="scope">
            <div style="cursor: pointer; width: 100%">
              <span @click="CluesDetail(scope.row.thread_id)" class="dot"
                style="display: inline-block; color: rgb(87, 135, 255)">{{ scope.row.thread_score }}</span>
            </div>
          </template>
        </el-table-column>
        <!--      @mouseover="mouseover(scope.row.thread_id)" -->
        <el-table-column label="沟通次数" width="100" prop="communicat_times">
          <template slot-scope="scope">
            <span class="count_style">{{ scope.row.communicat_times }}</span>
          </template>
        </el-table-column>
        <el-table-column sortable label="最近联系时间" width="160" prop="last_communticat_at">
          <template slot-scope="scope">
            <!--          <span-->
            <!--            @click="enter(scope.row.thread_id)"-->
            <!--            class="count_style"-->
            <!--            style="display: inherit">{{scope.row.last_communicat_at}}-->
            <!--          </span>-->
            <el-popover placement="right" trigger="click" width="600">
              <div class="popoverList">
                <el-timeline>
                  <el-timeline-item class="time_class" v-if="activitiesShow.length"
                    v-for="(activity, index) in activitiesShow" :key="index" :icon="activity.icon" :type="activity.type"
                    :color="activity.color" :size="activity.size">
                    <span style="color: #666666; display: inline-block; margin-bottom: 0.2rem">{{ activity.uname + "于"
                      }}</span>
                    <span style="color: #666666">
                      <!-- {{ activity.created_time }} -->
                      <date-formatter :date-value="activity.created_time"></date-formatter>
                    </span>

                    <span style="color: #666666">{{ activity.communicat_type }}</span>
                    <div class="time_right">
                      <span>{{ activity.communication_note }}</span>
                    </div>
                    <div class="time_right">
                      <el-link class="handleLinkImg" v-for="(items, indexs) in activity.preview" :key="indexs"
                        @click="handleLinkImgS(indexs, index)" type="primary">
                        {{ "图片" + (indexs + 1) }}
                      </el-link>
                    </div>
                  </el-timeline-item>
                  <div v-if="!activitiesShow.length">没有记录</div>
                </el-timeline>
              </div>
              <el-button style="padding: 0; border: 0" slot="reference" @click="enter(scope.row.thread_id)">
                <!-- {{ scope.row.last_communicat_at }} -->
                <date-formatter :date-value="scope.row.last_communicat_at"></date-formatter>
              </el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column sortable label="领取时间" width="140">
          <template slot-scope="scope">
            <!-- <el-tooltip :content="scope.row.get_thread_at" placement="top"> -->
            <span class="count_style" style="display: inherit">
              <!-- {{ scope.row.get_thread_at }}  -->
              <date-formatter :date-value="scope.row.get_thread_at"></date-formatter>
            </span>
            <!-- </el-tooltip> -->
          </template>
        </el-table-column>
        <el-table-column label="沟通时长" width="100" prop="call_duration">
          <template slot-scope="scope">
            <span class="count_style">{{ scope.row.call_duration }}</span>
          </template>
        </el-table-column>
        <el-table-column sortable label="客户意向" prop="intention" width="120">
          <template slot-scope="scope">
            <span class="count_style" style="display: inherit">{{
        scope.row.intention
      }}</span>
          </template>
        </el-table-column>
        <el-table-column label="预成交单号" width="120" prop="wait_order_number">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.wait_order_number" placement="top">
              <span class="count_style" style="display: inherit">{{
        scope.row.wait_order_number
      }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column v-for="(item, index) in col" :key="index" :label="item.label" :width="tableColumn(item.prop)">
          <template slot-scope="scope">
            <el-tooltip v-if="item.prop === 'page_title'" :content="scope.row[item.prop] + ''" placement="top">
              <span class="count_style" style="display: inherit">{{
        scope.row[item.prop]
      }}</span>
            </el-tooltip>
            <span v-else-if="item.prop === 'is_order'">
              <el-tooltip content="点击查看会员订单" placement="top" v-if="scope.row.is_order">
                <span class="count_style" style="display: inherit"><el-link><strong style="color: #409eff"
                      @click="openMemberInfoDrawer(scope.row.custom_phone)">是</strong></el-link></span>
              </el-tooltip>
              <span class="count_style" style="display: inherit" v-else>否</span>
            </span>
            <span v-else-if="item.prop === 'is_member'">
              <el-tooltip content="点击查看会员信息" placement="top" v-if="scope.row.is_member">
                <span class="count_style" style="display: inherit"><el-link><strong style="color: #409eff"
                      @click="openMemberInfoDrawer(scope.row.custom_phone)">是</strong></el-link></span>
              </el-tooltip>
              <span class="count_style" style="display: inherit" v-else>否</span>
            </span>
            <span v-else-if="item.prop === 'custom_phone'">
              <el-tooltip :content="scope.row.custom_phone + ''" placement="top"
                style="display: inline-block; vertical-align: middle">
                <!-- <span @click="call2(scope.$index, scope.row)" class="count_style" style="display: inherit; cursor: pointer;"><i style="color: rgb(87, 135, 255)" class="el-icon-mobile-phone"></i><el-link style="color: #409EFF;cursor: pointer" @click.stop="openPhoneFromDraw(scope.row.custom_phone)">{{scope.row.custom_phone.substring(0,5) + '...'}}</el-link></span> -->
                <span @click="call2(scope.$index, scope.row)" class="count_style"
                  style="display: inherit; cursor: pointer"><el-link style="color: #409eff; cursor: pointer"
                    @click.stop="openPhoneFromDraw(scope.row.custom_phone)">{{
        scope.row.custom_phone
          ? scope.row.custom_phone.substring(0, 5) + "..."
          : ""
      }}</el-link></span>
                <!--             <span @click="lineNum === '1' ? call(scope.row.custom_phone, scope.$index, scope.row) : call2(scope.$index, scope.row)" class="count_style" style="display: inherit; cursor: pointer;"><i :style="lineNum === '1' ? 'color: #67C23A' : 'color: rgb(87, 135, 255)'" class="el-icon-mobile-phone"></i>{{scope.row.custom_phone}}</span> -->
              </el-tooltip>
              <el-tooltip effect="drak" content="电话外呼" placement="bottom"
                style="display: inline-block; vertical-align: middle">
                <i @click="call2(scope.$index, scope.row)" class="el-icon-phone-outline"
                  style="color: #409eff; cursor: pointer"></i>
              </el-tooltip>
            </span>
            <el-tooltip v-else :content="scope.row[item.prop]" placement="top">
              <span class="count_style" style="display: inherit">{{
        scope.row[item.prop]
      }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="咨询关键内容" prop="refer_content" width="120">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.refer_content" placement="top">
              <span class="count_style" style="display: inherit">{{
        scope.row.refer_content
      }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="140">
          <template slot-scope="scope">
            <!-- :disabled="scope.row.order_status===3" -->
            <el-tooltip class="item" effect="dark" content="录入沟通/反馈" placement="top">
              <el-button type="warning" size="mini" icon="el-icon-chat-dot-round"
                @click="handleContactOpen(scope.$index, scope.row)" circle></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="转成交" placement="top">
              <!--            :disabled="scope.row.order_status===3"-->
              <el-button type="success" size="mini" icon="el-icon-check"
                @click="handleSuccessOpen(scope.$index, scope.row)" circle></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="放弃线索" placement="top">
              <el-button type="info" :disabled="scope.row.order_status === 3" size="mini" icon="el-icon-close"
                @click="handleAbandonOpen(scope.$index, scope.row)" circle></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div v-else class="loading-placeholder">加载中，请稍后...</div>
    </el-main>

    <el-footer class="footer-style">
      <el-pagination background class="tr mt-10" layout="sizes, total, prev, pager, next, jumper"
        :hide-on-single-page="false" :current-page="search ? pageOption.currentPage2 : pageOption.currentPage"
        :page-sizes="[10, 20, 30, 50, 100, 500]" :page-size="pageOption.pageSize" :total="pageOption.total"
        @size-change="handleSizeChange" @current-change="handleCurrentChange">
      </el-pagination>
    </el-footer>

    <!-- title="号码归属地" -->
    <el-drawer title="" :visible.sync="phoneFromDraw" direction="rtl" :before-close="closePhoneFromDraw" size="50%">
      <template slot="title">
        <span style="color: #409eff; font-size: large"></span>
      </template>
      <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
        <el-row>
          <make-phone :phone1="phoneFrom_phone"></make-phone>
        </el-row>
      </div>
    </el-drawer>
    <el-drawer title="录入沟通" :visible.sync="ContactDrawer" direction="rtl" :before-close="handleAddDrawerBeforeClose"
      size="50%">
      <el-tabs style="padding: 0 0.2rem 0 0.4rem" v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="沟通信息" name="newCallInfo">
          <!-- 当前版本 -->
          <feed-back :orderId="nThreadId" :type="2" :isShow="true" :cType="checkType"></feed-back>
        </el-tab-pane>

        <el-tab-pane label="历史沟通记录" name="callInfo">
          <!-- 历史版本 -->
          <el-row>
            <el-col :span="24">
              <div class="block">
                <el-timeline>
                  <el-timeline-item class="time_class" v-for="(activity, index) in activities" :key="index"
                    :icon="activity.icon" :type="activity.type" :color="activity.color" :size="activity.size">
                    <span style="color: #666666; display: inline-block; margin-bottom: 0.2rem">{{ activity.uname + "于"
                      }}</span>
                    <span style="color: #666666">{{ activity.created_time }}</span>
                    <span style="color: #666666">{{ activity.communicat_type }}</span>
                    <div class="time_right">
                      <span>{{ activity.communication_note }}</span>
                    </div>
                    <div class="time_right">
                      <el-link class="handleLinkImg" v-for="(items, indexs) in activity.preview" :key="indexs"
                        @click="handleLinkImg(indexs, index)" type="primary">
                        {{ "图片" + (indexs + 1) }}
                      </el-link>
                    </div>
                    <div class="m_comment public" v-if="activity.son" v-for="(item, id) in activity.son" :key="id">
                      <div class="comment_name_time">
                        <span class="comment_name">{{ item.username }}</span>
                        <span class="comment_time">{{ item.created_at }}</span>
                      </div>
                      <div class="comment_content">
                        <span class="cot">{{ item.communicat_content }}</span>
                      </div>
                    </div>
                  </el-timeline-item>
                </el-timeline>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="基础信息" name="first">
          <div class="m-tabs-content">
            <el-row>
              <el-col :span="4" class="m-label">客户状态：</el-col>
              <el-col :span="7">
                <el-select v-model="basicCluesData.status" @change="handelSaveChange('status', '客户状态')"
                  placeholder="请选择" :size="inputSize" clearable>
                  <el-option :value="1" label="跟踪中"></el-option>
                  <el-option :value="4" label="成单待确认"></el-option>
                  <el-option :value="3" label="无法联系"></el-option>
                </el-select>
              </el-col>
              <el-col :span="4" :offset="1" class="m-label">客户姓名：</el-col>
              <el-col :span="7" class="m-label">
                <el-input v-model="basicCluesData.custom_name" :size="inputSize"
                  @change="handelSaveChange('custom_name', '客户姓名')" clearable></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4" class="m-label" style="display: flex">客户性格：
                <i style="color: #4c87fc; cursor: pointer" class="el-icon-question"
                  @click="clientTraitClick()"></i></el-col>
              <el-col :span="7" class="m-label">
                <el-select :filterable="true" v-model="basicCluesData.custom_trait"
                  @change="handelSaveChange('custom_trait', '客户性格')" placeholder="请选择客户性格" :size="inputSize" clearable>
                  <el-option v-for="item in clientCharacter" :key="item.id" :label="item.title" :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4" :offset="1" class="m-label">客户性别：</el-col>
              <el-col :span="7">
                <el-select v-model="basicCluesData.custom_sex" @change="handelSaveChange('custom_sex', '客户性别')"
                  placeholder="请选择" :size="inputSize" clearable>
                  <el-option :value="1" label="未知"></el-option>
                  <el-option :value="2" label="男"></el-option>
                  <el-option :value="3" label="女"></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4" class="m-label" style="display: flex">客户类型：
                <i style="color: #4c87fc; cursor: pointer" class="el-icon-question"
                  @click="clientTypeClick()"></i></el-col>
              <el-col :span="7" class="m-label">
                <el-select :filterable="true" v-model="basicCluesData.custom_type"
                  @change="handelSaveChange('custom_type', '客户类型')" placeholder="请选择客户类型" :size="inputSize" clearable>
                  <el-option v-for="item in clientType" :key="item.id" :label="item.title" :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4" :offset="1" class="m-label">主营行业：</el-col>
              <el-col :span="7">
                <el-select :filterable="true" v-model="basicCluesData.custom_industry"
                  @change="handelSaveChange('custom_industry', '主营行业')" placeholder="请选择主营行业" :size="inputSize"
                  clearable>
                  <el-option v-for="item in industry" :key="item.industry_id" :label="item.industry_name"
                    :value="item.industry_id">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4" class="m-label">所属省市：</el-col>
              <el-col :span="7" class="m-label">
                <el-cascader ref="cascaderAddr" placeholder="请选择城市" style="width: 100%" v-model="value" filterable
                  :props="optionProps" :options="options" :size="inputSize" @change="handelArrangeCity"
                  :filter-method="filterOptions"></el-cascader>
              </el-col>
              <el-col :span="4" :offset="1" class="m-label">客户手机号：</el-col>
              <!--  <el-col :span="7" v-if="basicCluesData.custom_phone"  class="m-label"><span>{{basicCluesData.custom_phone}}</span></el-col>-->
              <el-col :span="7" class="m-label">
                <el-input v-model="basicCluesData.custom_phone" :size="inputSize"
                  @change="handelSaveChange('custom_phone', '客户手机号')" clearable></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4" class="m-label">手机省市：</el-col>
              <el-col :span="7" class="m-label"><span>{{
        basicCluesData.phone_province ? basicCluesData.phone_province : "暂无"
      }}</span></el-col>
              <el-col :span="4" :offset="1" class="m-label">微信号：</el-col>
              <el-col :span="7" class="m-label">
                <el-input v-model="basicCluesData.wechat_account" @change="handelSaveChange('wechat_account', '微信号')"
                  :size="inputSize" clearable></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4" class="m-label">
                <el-tooltip content="是否涉及特殊行业：" placement="top">
                  <span class="count_style" style="display: inherit">是否涉及特殊行业：</span>
                </el-tooltip>
              </el-col>
              <el-col :span="7" class="m-label">
                <el-radio-group v-model="basicCluesData.is_special_industry"
                  @change="handelSaveChange('is_special_industry', '是否涉及特殊行业')">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </el-col>
              <el-col v-if="basicCluesData.is_special_industry === 1" :span="4" :offset="1"
                class="m-label">许可证：</el-col>
              <el-col v-if="basicCluesData.is_special_industry === 1" :span="7">
                <el-select :filterable="true" v-model="basicCluesData.license"
                  @change="handelSaveChange('license', '许可证')" placeholder="请选择许可证" :size="inputSize" clearable>
                  <el-option v-for="item in licenseData" :key="item.license_id" :label="item.license_name"
                    :value="item.license_id">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4" class="m-label">年营业额：</el-col>
              <el-col :span="7">
                <el-select :filterable="true" v-model="basicCluesData.custom_turnover"
                  @change="handelSaveChange('custom_turnover', '年营业额')" placeholder="请选择年营业额" :size="inputSize"
                  clearable>
                  <el-option v-for="item in clientCompanyTurnover" :key="item.id" :label="item.title" :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4" :offset="1" class="m-label">员工数量：</el-col>
              <el-col :span="7">
                <el-select :filterable="true" v-model="basicCluesData.custom_staff"
                  @change="handelSaveChange('custom_staff', '员工数量')" placeholder="请选择员工数量" :size="inputSize" clearable>
                  <el-option v-for="item in clientCompanyStaffNum" :key="item.id" :label="item.title" :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4" class="m-label">
                <el-tooltip content="客户套餐需求：" placement="top">
                  <span class="count_style" style="display: inherit">客户套餐需求：</span>
                </el-tooltip>
              </el-col>
              <el-col :span="7" class="m-label">
                <el-select :filterable="true" v-model="basicCluesData.need_combo"
                  @change="handelSaveChange('need_combo', '客户套餐需求')" placeholder="请选择客户套餐需求" :size="inputSize"
                  clearable>
                  <el-option v-for="item in combo" :key="item.combo_id" :label="item.combo_name" :value="item.combo_id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4" :offset="1" class="m-label">客户来源：</el-col>
              <el-col :span="7">
                <el-select :filterable="true" v-model="basicCluesData.custom_source"
                  @change="handelSaveChange('custom_source', '客户来源')" placeholder="请选择客户来源" :size="inputSize" clearable>
                  <el-option v-for="item in customSource" :key="item.source_id" :label="item.source_name"
                    :value="item.source_id">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4" class="m-label">
                <el-tooltip content="套餐不需要的原因：" placement="top">
                  <span class="count_style" style="display: inherit">套餐不需要的原因：</span>
                </el-tooltip>
              </el-col>
              <el-col :span="7" class="m-label">
                <el-select :filterable="true" v-model="basicCluesData.not_need_cause"
                  @change="handelSaveChange('not_need_cause', '套餐不需要的原因')" placeholder="请选择套餐不需要的原因" :size="inputSize"
                  clearable>
                  <el-option v-for="item in notNeedCause" :key="item.not_id" :label="item.not_name"
                    :value="item.not_id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4" :offset="1" class="m-label">
                <el-tooltip content="客户可能需要的服务：" placement="top">
                  <span class="count_style" style="display: inherit">客户可能需要的服务：</span>
                </el-tooltip>
              </el-col>
              <el-col :span="7">
                <el-select :filterable="true" v-model="basicCluesData.maybe_need_server"
                  @change="handelSaveChange('maybe_need_server', '客户可能需要的服务')" placeholder="请选择客户可能需要的服务"
                  :size="inputSize" clearable>
                  <el-option v-for="item in SelectItem" :key="item.item_id" :label="item.item_name"
                    :value="item.item_id">
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4" class="m-label">
                <el-tooltip content="是否涉及其他需求：" placement="top">
                  <span class="count_style" style="display: inherit">是否涉及其他需求：</span>
                </el-tooltip>
              </el-col>
              <el-col :span="7" class="m-label">
                <el-select :filterable="true" v-model="basicCluesData.is_orther_need"
                  @change="handelSaveChange('is_orther_need', '是否涉及其他需求')" placeholder="请选择是否涉及其他需求" :size="inputSize"
                  clearable>
                  <el-option v-for="item in clientElseNeed" :key="item.id" :label="item.title" :value="item.id">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="4" :offset="1" class="m-label">备注：</el-col>
              <el-col :span="7">
                <el-input type="textarea" :autosize="textareaSize2" @change="handelSaveChange('remark', '备注')"
                  v-model="basicCluesData.remark" clearable></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4" class="m-label">咨询分类：</el-col>
              <el-col :span="7" class="m-label"><span>{{ basicCluesData.refer_cate }}</span></el-col>
              <el-col :span="4" :offset="1" class="m-label">园区：</el-col>
              <el-col :span="7" class="m-label">
                <el-select v-model="basicCluesData.garden" @change="handelSaveChange('garden', '园区')" placeholder="请选择"
                  :size="inputSize" clearable>
                  <el-option :value="1" label="上海园区"></el-option>
                  <el-option :value="2" label="南京园区"></el-option>
                  <el-option :value="3" label="徐州园区"></el-option>
                  <el-option :value="4" label="其他园区"></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4" class="m-label">群聊ID：</el-col>
              <el-col :span="7" class="m-label">
                <el-input v-model="basicCluesData.group_chat_id" @change="handelSaveChange('group_chat_id', '群聊ID')"
                  :size="inputSize" clearable></el-input>
              </el-col>
              <el-col :span="4" :offset="1" class="m-label">页面标题：</el-col>
              <el-col :span="7" class="m-label">
                <el-input v-model="basicCluesData.page_title" @change="handelSaveChange('page_title', '页面标题')"
                  :size="inputSize" clearable></el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4" class="m-label">IM人员：</el-col>
              <el-col :span="7" class="m-label"><span>{{ basicCluesData.im_name }}</span></el-col>
              <el-col :span="4" class="m-label">
                <el-tooltip content="是否添加微信：" placement="top">
                  <span class="count_style" style="display: inherit">是否添加微信：</span>is_add_wx
                </el-tooltip>
              </el-col>
              <el-col :span="7" class="m-label">
                <el-radio-group v-model="basicCluesData.is_add_wx" @change="handelSaveChange('is_add_wx', '是否添加微信：')">
                  <el-radio :label="1">否</el-radio>
                  <el-radio :label="2">是</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="4" class="m-label">
                <el-tooltip content="咨询关键内容：" placement="top">
                  <span class="count_style" style="display: inherit">咨询关键内容：</span>
                </el-tooltip>
              </el-col>
              <el-col :span="20" class="m-label">
                <el-input type="textarea" :autosize="textareaSize" @change="handelSaveChange('refer_content', '咨询关键内容')"
                  v-model="basicCluesData.refer_content" clearable></el-input>
              </el-col>
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label="电话沟通" name="calls">
          <el-row>
            <el-col :span="24">
              <span>{{ row.custom_name }}</span>
              <span style="cursor: pointer" @click="handelcall(row.custom_phone)">{{ row.custom_phone }}
                <i class="el-icon-phone-outline" style="color: rgb(87, 135, 255)"></i></span>
            </el-col>
          </el-row>
          <el-table :data="callPageData" size="mini" border style="width: 100%; margin-top: 0.2rem">
            <el-table-column label="姓名">
              <template slot-scope="scope">
                {{ scope.row.user ? scope.row.user.username : "测试" }}
              </template>
            </el-table-column>
            <el-table-column label="主叫号码">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.caller" placement="top">
                  <span class="count-style">{{ scope.row.caller }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="被叫号码">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.callee" placement="top">
                  <span class="count-style">{{ scope.row.callee }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="通话状态">
              <template slot-scope="scope">
                <el-tooltip v-if="scope.row.ul_fail_reason" :content="scope.row.ul_fail_reason" placement="top">
                  <span class="count-style">{{ scope.row.ul_fail_reason }}</span>
                </el-tooltip>
                <span v-else>待处理</span>
              </template>
            </el-table-column>
            <el-table-column label="时长(秒)">
              <template slot-scope="scope">
                <span>{{ scope.row.billsec }}</span>
                <i v-if="scope.row.record_flag === 1" style="color: #5cb6ff; font-size: 0.4rem; cursor: pointer"
                  class="el-icon-mic" @click="
        play(scope.row.file_storage, scope.row.record_file_download_url)
        "></i>
              </template>
            </el-table-column>
            <el-table-column label="呼叫时间">
              <template slot-scope="scope">
                <el-tooltip :content="scope.row.fwd_start_time" placement="top">
                  <span class="count-style">{{ scope.row.fwd_start_time }}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="备注">
              <template slot-scope="scope">
                <el-tooltip v-if="scope.row.remark" :content="scope.row.remark" placement="top">
                  <span class="count-style">{{ scope.row.remark }}</span>
                </el-tooltip>
                <el-button v-else icon="el-icon-plus" size="mini" circle
                  @click="submitRemark(scope.row.id, scope.$index)"></el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination background class="mt-10 text-r" layout="total, prev, pager, next, jumper"
            :hide-on-single-page="false" :current-page="callPageOption.currentPage" :page-size="callPageOption.pageSize"
            :total="callPageOption.total" @current-change="handleCallCurrentChange">
          </el-pagination>
        </el-tab-pane>
        <!-- v-if="deal" -->
        <el-tab-pane label="线索共享人" name="share">
          <div style="margin-top: 0.2rem">
            <el-select v-model="shareSelect" multiple placeholder="请选择" size="mini" @click.native="addShareC"
              style="display: inline-block" @change="doAddShare" :disabled="notAgin" filterable>
              <el-option v-for="item in shareOptions" :key="item.id" :disabled="item.disabled" :label="item.username"
                :value="item.id + '|' + item.username">
              </el-option>
            </el-select>
            <!-- <div style="margin-top:0.2rem;text-align:right">
          <el-button type="primary" size="mini" @click="doAddShare">添加</el-button>
        </div> -->
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="共享人" name="shared"></el-tab-pane> -->
        <el-tab-pane label="线索历史" name="second" v-if="pageNodes.indexOf('线索历史') !== -1">
          <div class="blocka">
            <el-timeline>
              <el-timeline-item v-for="(OperationRecord, index) in OperationRecord" :key="index"
                :timestamp="OperationRecord.created_at" placement="top">
                <el-card>
                  <p>{{ OperationRecord.operate }}</p>
                </el-card>
              </el-timeline-item>
            </el-timeline>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-drawer>
    <el-drawer title="" :visible.sync="memberInfoDrawer" direction="rtl" :before-close="handleClose_memberInfoDrawer"
      size="50%">
      <template slot="title">
        <span style="color: #409eff; font-size: 0.3rem; font-weight: bold">会员信息</span>
      </template>
      <div style="padding: 0.2em 1.4em; margin-top: 0.3rem">
        <member-info :phone="memberPhone"></member-info>
      </div>
    </el-drawer>
    <el-dialog title="转成交" :visible.sync="dialogVisible" width="80%" :before-close="handleAddDrawerBeforeClose">
      <div class="contents">
        <el-row>
          <el-col style="margin-bottom: 0.4rem" :span="24">
            <el-select :filterable="true" v-model="selectOrderType" placeholder="请选择订单类型"
              @change="handleSelectOrderType" size="small" clearable>
              <el-option v-for="item in optionOrder" :key="item.order_reg_id" :label="item.order_reg_name"
                :value="item.order_reg_id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row v-if="selectOrderType === 5">
          <el-col style="margin-bottom: 0.4rem" :span="24">
            <el-select :filterable="true" v-model="selectItem" placeholder="请选择单品类型" size="small" clearable>
              <el-option v-for="item in optionItem" :key="item.item_id" :label="item.item_name" :value="item.item_id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-input prefix-icon="" @change="searchOrderNum" v-model="order_num" size="small"
          placeholder="请输入手机号或订单号查询订单" />
        <div v-if="searchData" class="tables" style="background: #ecf4ff; margin-top: 0.4rem">
          <span class="spans" style="width: 10%">选择订单</span>
          <span class="spans" style="width: 20%">订单号</span>
          <span class="spans" style="width: 10%">客户姓名</span>
          <span class="spans" style="width: 15%">客户手机号</span>
          <span class="spans" style="width: 20%">派单时间</span>
          <span class="spans" style="width: 15%">订单类型</span>
          <span class="spans" style="width: 10%">单品名称</span>
        </div>
        <div v-if="searchData" class="tables" v-for="(item, index) in orderNum" :key="index">
          <div style="width: 10%">
            <el-radio-group v-model="radio" size="small">
              <el-radio class="radios" :label="item.order_id">{{ "" }}</el-radio>
            </el-radio-group>
          </div>
          <div style="width: 20%">
            <span>{{ item.order_num }}</span>
          </div>
          <div style="width: 10%">
            <span>{{ item.custom_name }}</span>
          </div>
          <div style="width: 15%">
            <span>{{ item.custom_phone }}</span>
          </div>
          <div style="width: 20%">
            <span>{{ item.assign_at }}</span>
          </div>
          <div style="width: 15%">
            <span>{{ item.refer_cate }}</span>
          </div>
          <div style="width: 10%">
            <span>{{ item.item_name }}</span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="HandleDialogVisibleClose">取 消</el-button>
        <el-button size="mini" type="primary" @click="HandleDialogVisible">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible2" class="el_dialogs" width="45%">
      <div class="box_title">
        <span>等级规则介绍</span>
        <i style="color: #4c87fc" class="el-icon-question"></i>
      </div>
      <div class="dialog_box">
        <p class="box_p">每周日晚上凌晨自动计算一次。</p>
        <p class="box_p">所在等级匹配相应仓位，</p>
        <p class="box_p">
          若是被降级，保持现有的线索，不能再领取，不能超过当前仓位，只能通过放弃到当前等级对应的仓位以下才能领取新线索。
        </p>
        <img src="../../assets/image/level.png" />
      </div>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible3" class="el_dialogs" width="45%">
      <div class="box_title">
        <span>客户意向</span>
        <i style="color: #4c87fc" class="el-icon-question"></i>
      </div>
      <div class="dialog_box dialog_img">
        <img src="../../assets/image/intention.png" />
      </div>
      <span slot="footer" class="dialog-footer"> </span>
    </el-dialog>
    <el-dialog title="选择转让人员" :visible.sync="dialogVisibleClues" width="25%">
      <div class="contents" style="margin-bottom: 0">
        <p style="margin-bottom: 0.4rem; font-weight: bold; color: red">
          成单待确认、已完成的线索不可转让
        </p>
        <el-select style="width: 100%" :filterable="true" v-model="allotData.uid" placeholder="请选择转让人员" size="mini"
          clearable>
          <el-option v-for="(item, index) in ConversionPeople" :key="index" :label="item.username" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="HandleDialogVisibleCluesClose">取 消</el-button>
        <el-button size="mini" type="primary" @click="HandleDialogVisibleClues">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="线索详情" width="80%" :visible.sync="dialogTableVisible">
      <div class="m-tabs-content">
        <div class="listClues public">
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.status ? '' : '#4d84fe' }">客户状态：</span>{{ cluesData.status }}</span>
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.custom_name ? '' : '#4d84fe' }">客户姓名：</span>{{ cluesData.custom_name }}</span>
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.custom_phone ? '' : '#4d84fe' }">客户手机：</span>{{ cluesData.custom_phone
            }}</span>
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.custom_sex ? '' : '#4d84fe' }">客户性别：</span>{{ cluesData.custom_sex }}</span>
        </div>
        <div class="listClues public">
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.custom_city_name ? '' : '#4d84fe' }">所属省份：</span>{{ cluesData.custom_city_name
            }}</span>
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.phone_province ? '' : '#4d84fe' }">手机省份：</span>{{ cluesData.phone_province
            }}</span>
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.wechat_account ? '' : '#4d84fe' }">微信账号：</span>{{ cluesData.wechat_account
            }}</span>
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.group_chat_id ? '' : '#4d84fe' }">群聊id：</span>{{ cluesData.group_chat_id
            }}</span>
        </div>
        <div class="listClues public">
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.custom_trait ? '' : '#4d84fe' }">客户性格：</span>{{ cluesData.custom_trait
            }}</span>
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.custom_type ? '' : '#4d84fe' }">客户类型：</span>{{ cluesData.custom_type }}</span>
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.custom_source ? '' : '#4d84fe' }">客户来源：</span>{{ cluesData.custom_source
            }}</span>
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.intention ? '' : '#4d84fe' }">客户意向：</span>{{ cluesData.intention }}</span>
        </div>
        <div class="listClues public">
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.input_type ? '' : '#4d84fe' }">线索类型：</span>{{ cluesData.input_type }}</span>
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.tag_code ? '' : '#4d84fe' }">线索编码：</span>{{ cluesData.tag_code }}</span>
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.thread_score ? '' : '#4d84fe' }">线索分数：</span>{{ cluesData.thread_score
            }}</span>
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.thread_type ? '' : '#4d84fe' }">录入类型：</span>{{ cluesData.thread_type }}</span>
        </div>
        <div class="listClues public">
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.page_title ? '' : '#4d84fe' }">页面标题：</span>{{ cluesData.page_title }}</span>
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.im_name ? '' : '#4d84fe' }">im姓名：</span>{{ cluesData.im_name }}</span>
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.garden ? '' : '#4d84fe' }">所属园区：</span>{{ cluesData.garden }}</span>
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.custom_industry ? '' : '#4d84fe' }">主营行业：</span>{{ cluesData.custom_industry
            }}</span>
        </div>
        <div class="listClues public">
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.last_communicat_at ? '' : '#4d84fe' }">最近联系时间：</span>{{
        cluesData.last_communicat_at }}</span>
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.call_duration ? '' : '#4d84fe' }">最近沟通时长：</span>{{ cluesData.call_duration
            }}</span>
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.communicat_times ? '' : '#4d84fe' }">沟通次数：</span>{{ cluesData.communicat_times
            }}</span>
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.communicat_return ? '' : '#4d84fe' }">沟通反馈：</span>{{
        cluesData.communicat_return
      }}</span>
        </div>
        <div class="listClues public">
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.username ? '' : '#4d84fe' }">负责人：</span>{{ cluesData.username }}</span>
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.created_at ? '' : '#4d84fe' }">创建时间：</span>{{ cluesData.created_at }}</span>
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.get_thread_at ? '' : '#4d84fe' }">领取时间：</span>{{ cluesData.get_thread_at
            }}</span>
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.updated_at ? '' : '#4d84fe' }">修改时间：</span>{{ cluesData.updated_at }}</span>
        </div>
        <div class="listClues public">
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.refer_cate ? '' : '#4d84fe' }">咨询分类：</span>{{ cluesData.refer_cate }}</span>
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.refer_content ? '' : '#4d84fe' }">咨询关键内容：</span>{{ cluesData.refer_content
            }}</span>
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.is_special_industry ? '' : '#4d84fe' }">是否为特殊行业：</span>{{
        cluesData.is_special_industry }}</span>
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.license ? '' : '#4d84fe' }">许可证：</span>{{ cluesData.license }}</span>
        </div>
        <div class="listClues public">
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.custom_turnover ? '' : '#4d84fe' }">客户年营业额：</span>{{ cluesData.custom_turnover
            }}</span>
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.custom_staff ? '' : '#4d84fe' }">客户员工数：</span>{{ cluesData.custom_staff
            }}</span>
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.need_combo ? '' : '#4d84fe' }">客户套餐需求：</span>{{ cluesData.need_combo }}</span>
          <span class="counts"><span class="listCluesTitle"
              :style="{ color: cluesData.remark ? '' : '#4d84fe' }">备注：</span>{{ cluesData.remark }}</span>
        </div>
        <div class="listClues public">
          <span class="counts" style="width: 33.33%"><span class="listCluesTitle"
              :style="{ color: cluesData.not_need_cause ? '' : '#4d84fe' }">套餐不需要的原因：</span>{{ cluesData.not_need_cause
            }}</span>
          <span class="counts" style="width: 33.33%"><span class="listCluesTitle"
              :style="{ color: cluesData.maybe_need_server ? '' : '#4d84fe' }">客户可能需要的服务：</span>{{
            cluesData.maybe_need_server }}</span>
          <span class="counts" style="width: 33.33%"><span class="listCluesTitle"
              :style="{ color: cluesData.is_other_need ? '' : '#4d84fe' }">是否涉及其他需求：</span>{{ cluesData.is_other_need
            }}</span>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="备注" :visible.sync="remarkVisible" width="40%" :modal="false" :before-close="handleRemarkClose">
      <div>
        <el-input v-model="remarkFrom.remark" type="textarea" :rows="2" placeholder="请输入内容"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="handelRemarkSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="播放" :visible.sync="dialogPlayVisible" :append-to-body="true"
      :before-close="dialogPlayVisibleBeforeClose">
      <el-row class="playCon">
        <el-card class="card" :body-style="{ padding: '10px' }">
          <div id="waveform" ref="waveform"></div>
        </el-card>
        <div style="padding: 10px" id="wave-timeline" ref="wave-timeline"></div>
      </el-row>
      <div class="text-c">
        <el-button type="primary" @click="playMusic" size="mini">
          <i :class="[isPlay ? 'el-icon-video-pause' : 'el-icon-video-play']"></i>
          {{ isPlay ? "暂停" : "播放" }}
        </el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import WaveSurfer from "wavesurfer.js";
import MemberInfo from "common/MemberInfo";
import Timeline from "wavesurfer.js/dist/plugin/wavesurfer.timeline.js";
import img1 from "../../assets/image/qingtong.png";
import img2 from "../../assets/image/baiyin.png";
import img3 from "../../assets/image/huangjin.png";
import img4 from "../../assets/image/bojin.png";
import img5 from "../../assets/image/zuanshi.png";
import img6 from "../../assets/image/wangzhe.png";
import MakePhone from "common/MakePhone";
import FeedBack from "common/FeedBack";
import DateFormatter from "common/DateFormatter";
import { filterKeywordOptions } from '../../lib/cascaderUtils.js';
import PhoneCom from 'common/PhoneCom'

export default {
  name: "clues",
  components: { MemberInfo, MakePhone, FeedBack, DateFormatter, PhoneCom },
  data() {
    return {
      activeOpen: "",
      phoneFrom_phone: [],
      phoneFromDraw: false,
      memberPhone: null,
      memberInfoDrawer: false,
      lineNum: "1",
      uploadHeader: { Authorization: localStorage.token },
      imgPath: this.$store.state.imgPath,
      // imgPath: 'http://192.168.1.110/storage/',
      materialFlieList: [],
      materialFlieListSub: [],
      search: "",
      searchData: false,
      radio: "",
      orderNum: [],
      nThreadId: "",
      intentionData: {},
      NVipData: "",
      shareTotal: "",
      img: "",
      nPage: 1,
      textarea: "",
      selectOrderType: "",
      order_num: "",
      selectItem: "",
      user_thread_number: "",
      today_communicat: "",
      repeat_count: "",
      no_relation: "",
      inputSize: "small",
      activeName: "newCallInfo",
      licenseList: [],
      formData: [],
      loading: true,
      addPicForm: {
        intention: null,
        communicat_type: null,
        communication_note: "",
        keyword_cate: null,
        keyword: [],
        has_contacted: null,
        is_notice: "0",
        next_contact_time: null,
      },
      activities: [],
      OperationRecord: [],
      statusColor: 1,
      textareaSize: { minRows: 3, maxRows: 5 },
      textareaSize2: { minRows: 2, maxRows: 4 },
      value1: [],
      value5: false,
      value6: false,
      value7: false,
      value8: false,
      options: [],
      value3: [],
      value2: [],
      value: [],
      vipData: {},
      company_allot: {},
      vipName: "",
      vipNum: 0,
      vipIcon: "",
      counts: {
        unassigned: 0,
        in_service: 0,
        refund: 0,
        service_complete: 0,
      },
      CluesPool: [],
      switchValueIndustry: false,
      basicCluesData: {
        index: null,
        id: 0,
        status: "",
        custom_name: "",
        custom_sex: "",
        custom_trait: "",
        custom_type: "",
        is_special_industry: "",
        is_add_wx: "",
        licence: "",
        need_combo: "",
        custom_turnover: "",
        custom_staff: "",
        not_need_cause: "",
        maybe_need_server: "",
        is_orther_need: "",
        remark: "",
        license: "",
        custom_source: "",
        custom_industry: "",
        customer_city: "",
        custom_phone: "",
        phone_province: "",
        wechat_account: "",
        custom_province: "",
        custom_city: "",
        refer_cate: "",
        refer_content: "",
        group_chat_id: "",
        page_title: "",
        im_name: "",
        intention: "",
        communicat_type: "",
        is_phone_connect: 0,
        call_duration: "",
        garden: "",
        files: [],
      },
      sharePop: false,
      shareSelect: [],
      shareOptions: [],
      pageOption: {
        total: 0,
        currentPage: 1, // 当前页数
        currentPage2: 1, // 当前页数
        pageSize: 30, // 每页显示条数
      },
      dialogVisible: false,
      dialogVisible2: false,
      dialogVisible3: false,
      ContactDrawer: false,
      SuccessDrawer: false,
      AbandonDrawer: false,
      addForm: {
        client_intention: "",
        communication_note: "",
        communicat_type: "",
      },
      clientCharacter: [
        { title: "未知", id: 1 },
        { title: "老鹰型", id: 2 },
        { title: "孔雀型", id: 3 },
        { title: "鸽子型", id: 4 },
        { title: "猫头鹰型", id: 5 },
      ],
      clientType: [
        { title: "未知", id: 1 },
        { title: "犹豫不决型", id: 2 },
        { title: "喜欢挑剔型", id: 3 },
        { title: "傲慢无礼型", id: 4 },
        { title: "牢骚抱怨型", id: 5 },
        { title: "经济型", id: 6 },
        { title: "不直接拒绝型", id: 7 },
        { title: "装懂非懂型", id: 8 },
        { title: "自我炫耀型", id: 9 },
        { title: "老实巴交型", id: 10 },
        { title: "沉着老练型", id: 11 },
      ],
      clientCompanyTurnover: [
        { title: "未知", id: 1 },
        { title: "10万", id: 2 },
        { title: "50万", id: 3 },
        { title: "100万", id: 4 },
        { title: "300万", id: 5 },
        { title: "500万以上", id: 6 },
      ],
      clientCompanyStaffNum: [
        { title: "1-5人", id: 1 },
        { title: "6-10人", id: 2 },
        { title: "11-30人", id: 3 },
        { title: "31-50人", id: 4 },
        { title: "51-100人", id: 5 },
        { title: "101人以上", id: 6 },
      ],
      clientElseNeed: [
        { title: "入驻电商", id: 1 },
        { title: "自媒体", id: 2 },
        { title: "公众号", id: 3 },
        { title: "小程序", id: 4 },
        { title: "短视频", id: 5 },
        { title: "参与竞标", id: 6 },
        { title: "参与比赛", id: 7 },
      ],
      combo: [],
      industry: [],
      SelectItem: [],
      licenseData: [],
      customSource: [],
      notNeedCause: [],
      deal: false,
      highSearch: {
        group_chat_id: "",
        im_name: "",
        refer_cate: "",
        custom_city_name: [],
        start_time: "",
        end_time: "",
        type: 0,
        status: [],
        intention: "",
        garden: "",
        last_communicat_at: 0,
        communicat_at: [],
        custom_sex: "",
        custom_trait: [],
        custom_type: [],
        custom_industry: [],
        custom_turnover: [],
        custom_staff: [],
        is_special_industry: "",
        is_add_wx: "",
        license: [],
        need_combo: "",
        maybe_need_server: "",
        custom_source: "",
        thread_score: "",
        get_thread_at: [],
        is_member: "",
      },
      optionProps: {
        value: "id",
        label: "Provincial",
        children: "son",
      },
      col: [
        {
          label: "所属省市",
          prop: "custom_city_name",
          display: false,
        },
        // {
        //   label: "客户手机",
        //   prop: "custom_phone",
        //   display: false,
        // },
        {
          label: "是否订单",
          prop: "is_order",
          display: false,
        },
        {
          label: "是否会员",
          prop: "is_member",
          display: false,
        },
        {
          label: "手机省份",
          prop: "phone_province",
          display: false,
        },
        {
          label: "微信号",
          prop: "wechat_account",
          display: false,
        },
        {
          label: "咨询分类",
          prop: "refer_cate",
          display: false,
        },
        {
          label: "群聊ID",
          prop: "group_chat_id",
          display: false,
        },
        {
          label: "页面标题",
          prop: "page_title",
          display: false,
        },
        {
          label: "IM人员",
          prop: "im_name",
          display: false,
        },
        {
          label: "园区",
          prop: "garden",
          display: false,
        },
        {
          label: "线索来源",
          prop: "input_type",
          display: false,
        },
      ],
      row: {},
      index: 0,
      cluesIndex: 0,
      ConversionPeople: [],
      activeNames: ["1"],
      gardenRelation: "",
      relation: false,
      value_city: [],
      serverTypes: [],
      GetServerTypes: [""],
      allotData: {
        uid: "",
        ids: [],
        username: "",
      },
      multipleSelection: [],
      dialogVisibleClues: false,
      pageNodes: [],
      optionOrder: [],
      optionItem: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick: (picker) => {
              picker.$emit("pick", [new Date(), new Date()]);
            },
          },
          {
            text: "昨天",
            onClick: (picker) => {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [date, date]);
            },
          },
          {
            text: "本周",
            onClick: (picker) => {
              picker.$emit("pick", [this.thisWeek()[0], this.thisWeek()[1]]);
            },
          },
          {
            text: "上周",
            onClick: (picker) => {
              picker.$emit("pick", [this.LastWeek()[0], this.LastWeek()[1]]);
            },
          },
          {
            text: "本月",
            onClick: (picker) => {
              picker.$emit("pick", [this.thisMonth()[0], this.thisMonth()[1]]);
            },
          },
          {
            text: "上个月",
            onClick: (picker) => {
              picker.$emit("pick", [this.LastMonth()[0], this.LastMonth()[1]]);
            },
          },
        ],
      },
      pickerOptionsContact: {
        shortcuts: [
          {
            text: "今天",
            onClick: (picker) => {
              picker.$emit("pick", [new Date(), new Date()]);
            },
          },
          {
            text: "昨天",
            onClick: (picker) => {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [date, date]);
            },
          },
          {
            text: "本周",
            onClick: (picker) => {
              picker.$emit("pick", [this.thisWeek()[0], this.thisWeek()[1]]);
            },
          },
          {
            text: "上周",
            onClick: (picker) => {
              picker.$emit("pick", [this.LastWeek()[0], this.LastWeek()[1]]);
            },
          },
          {
            text: "本月",
            onClick: (picker) => {
              picker.$emit("pick", [this.thisMonth()[0], this.thisMonth()[1]]);
            },
          },
          {
            text: "上个月",
            onClick: (picker) => {
              picker.$emit("pick", [this.LastMonth()[0], this.LastMonth()[1]]);
            },
          },
        ],
      },
      dialogTableVisible: false,
      cluesData: [],
      cluesDataTitle: [
        {
          label: "线索状态",
          prop: "status",
          display: false,
        },
        {
          label: "线索类型",
          prop: "input_type",
          display: false,
        },
        {
          label: "线索分数",
          prop: "thread_score",
          display: false,
        },
        {
          label: "线索编码",
          prop: "tag_code",
          display: false,
        },
        {
          label: "录入类型",
          prop: "thread_type",
          display: false,
        },
        {
          label: "所属园区",
          prop: "garden",
          display: false,
        },
        {
          label: "负责人",
          prop: "username",
          display: false,
        },
        {
          label: "客户姓名",
          prop: "custom_name",
          display: false,
        },
        // {
        //   label: "客户手机",
        //   prop: "custom_phone",
        //   display: false,
        // },
        {
          label: "手机省市",
          prop: "phone_province",
          display: false,
        },
        {
          label: "所属省市",
          prop: "custom_city_name",
          display: false,
        },
        {
          label: "客户性别",
          prop: "custom_sex",
          display: false,
        },
        {
          label: "客户性格",
          prop: "custom_trait",
          display: false,
        },
        {
          label: "客户类型",
          prop: "custom_type",
          display: false,
        },
        {
          label: "客户来源",
          prop: "custom_source",
          display: false,
        },
        {
          label: "客户年营业额",
          prop: "custom_turnover",
          display: false,
        },
        {
          label: "员工数量",
          prop: "custom_staff",
          display: false,
        },
        {
          label: "咨询分类",
          prop: "refer_cate",
          display: false,
        },
        {
          label: "咨询关键内容",
          prop: "refer_content",
          display: false,
        },
        {
          label: "页面标题",
          prop: "page_title",
          display: false,
        },
        {
          label: "im姓名",
          prop: "im_name",
          display: false,
        },
        {
          label: "微信账号",
          prop: "wechat_account",
          display: false,
        },
        {
          label: "群聊id",
          prop: "group_chat_id",
          display: false,
        },
        {
          label: "最近联系时间",
          prop: "last_communicat_at",
          display: false,
        },
        {
          label: "沟通次数",
          prop: "communicat_times",
          display: false,
        },
        {
          label: "最近沟通时长",
          prop: "call_duration",
          display: false,
        },
        {
          label: "沟通反馈",
          prop: "communicat_return",
          display: false,
        },
        {
          label: "主营行业",
          prop: "custom_industry",
          display: false,
        },
        {
          label: "是否为特殊行业",
          prop: "is_special_industry",
          display: false,
        },
        {
          label: "许可证",
          prop: "license",
          display: false,
        },
        {
          label: "客户套餐需求",
          prop: "need_combo",
          display: false,
        },
        {
          label: "套餐不需要的原因",
          prop: "not_need_cause",
          display: false,
        },
        {
          label: "客户可能需要的服务",
          prop: "maybe_need_server",
          display: false,
        },
        {
          label: "是否涉及其他需求",
          prop: "is_other_need",
          display: false,
        },
        {
          label: "客户可能需要的服务",
          prop: "maybe_need_server",
          display: false,
        },
        {
          label: "客户意向",
          prop: "intention",
          display: false,
        },
        {
          label: "备注",
          prop: "remark",
          display: false,
        },
      ],
      notAgin: false,
      gridData: [],
      visiblePopover: false,
      activitiesShow: [],
      callPageData: [],
      sharePageData: [],
      callPageOption: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      shareLabel: "",
      shareValue: "",
      remarkVisible: false,
      remarkFrom: {
        id: null,
        index: null,
        remark: "",
      },
      wavesurfer: null,
      dialogPlayVisible: false,
      isPlay: false,
      chat_methods: [],
      keywords: [],
      reflects: [],
      keywordCates: [],
      checkType: this.$feedBackConfig.clue_chat,
    };
  },
  computed: {
    pageData: function () {
      var currentPage = this.search
        ? this.pageOption.currentPage2
        : this.pageOption.currentPage;
      return this.CluesPool.filter(
        (data) =>
          !this.search ||
          (data.custom_name &&
            data.custom_name.toLowerCase().includes(this.search.toLowerCase())) ||
          (data.custom_phone &&
            data.custom_phone.toLowerCase().includes(this.search.toLowerCase())) ||
          (data.tag_code &&
            data.tag_code.toLowerCase().includes(this.search.toLowerCase()))
      ).slice(
        this.pageOption.pageSize * (currentPage - 1),
        this.pageOption.pageSize * currentPage
      );
    },
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === "development" ? "" : "https://weixin.qiyehuo.com";
      },
    },
    collapse() {
      return this.$store.state.collapse;
    },
  },
  watch: {
    search: function () {
      this.pageOption.total = this.search ? this.searchTotal() : this.CluesPool.length;
      this.pageOption.currentPage2 = 1;
    },
    CluesPool: function () {
      this.changeView();
    },
  },

  methods: {
    handelKeywordCateChange() {
      this.addPicForm.keyword = [];
      this.keywords = [];
      // 根据分类获取关键词
      this.$axios
        .post("api/admin/process/check/get_keyword_by_cate", {
          keyword_cate_id: this.addPicForm.keyword_cate,
        })
        .then(({ data }) => {
          if (data.code === 0) {
            this.keywords = data.data.result;
            // this.$message.success(data.msg)
          }
        })
        .catch();
    },
    handleReflectPreview(file) {
      let tempwindow = window.open("_blank");
      tempwindow.location = file.url;
    },
    openPhoneFromDraw(phone) {
      setTimeout(() => {
        this.phoneFrom_phone.push(phone);
      });
      this.phoneFromDraw = true;
    },
    closePhoneFromDraw(done) {
      this.phoneFrom_phone = [];
      done();
    },
    changeView() {
      var currentPage = this.search
        ? this.pageOption.currentPage2
        : this.pageOption.currentPage;
      return this.CluesPool.filter(
        (data) =>
          !this.search ||
          (data.custom_name &&
            data.custom_name.toLowerCase().includes(this.search.toLowerCase())) ||
          (data.custom_phone &&
            data.custom_phone.toLowerCase().includes(this.search.toLowerCase())) ||
          (data.tag_code &&
            data.tag_code.toLowerCase().includes(this.search.toLowerCase()))
      ).slice(
        this.pageOption.pageSize * (currentPage - 1),
        this.pageOption.pageSize * currentPage
      );
    },
    handleClose_memberInfoDrawer(done) {
      this.memberPhone = null;
      done();
    },
    openMemberInfoDrawer(phone) {
      this.memberInfoDrawer = true;
      setTimeout(() => {
        this.memberPhone = phone;
      });
    },
    CluesDetail(id) {
      this.$axios.get("/api/thread/detail/" + id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.dialogTableVisible = true;
          this.cluesData = data.data;
        }
      });
    },
    enter(id) {
      this.$axios.get("/api/thread/five_communicat_list/" + id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.handleForMethodsShow(id, data.data);
        }
      });
    },
    handleLinkImgS(indexs, index) {
      var tempwindow = window.open("_blank");
      tempwindow.location = this.activitiesShow[index].preview[indexs];
    },
    handleForMethodsShow(id, data) {
      for (var i = 0; i < this.pageData.length; i++) {
        if (id === this.pageData[i].thread_id) {
          this.activitiesShow = data;
          for (var a = 0; a < this.activitiesShow.length; a++) {
            if (this.activitiesShow[a].communicat_type === "电话联系") {
              let duration = data[a].call_duration === null ? " " : data[a].call_duration;
              this.activitiesShow[a].communicat_type =
                "通过 " + data[a].communicat_type + "与客户沟通了" + duration + "秒";
            } else {
              this.activitiesShow[a].communicat_type =
                "通过 " + data[a].communicat_type + "与客户进行了沟通";
            }
            if (data[a].communicat_img) {
              this.activitiesShow[a].preview = data[a].communicat_img.split(",");
            }
            this.activitiesShow[a].size = "large";
            this.activitiesShow[a].type = "primary";
            this.activitiesShow[a].icon = "el-icon-s-custom";
          }
        }
      }
    },
    getCluesType() {
      this.$axios.get("/api/threadstat/type_list").then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.combo = data.data.combo;
          this.industry = data.data.industry;
          this.SelectItem = data.data.item;
          this.licenseData = data.data.license;
          this.customSource = data.data.custom_source;
          this.notNeedCause = data.data.not_need_cause;
        }
      });
    },
    clientTraitClick() {
      window.open("https://www.doc88.com/p-740682684520.html?s=rel&id=1");
    },
    clientTypeClick() {
      window.open("https://www.sohu.com/a/371867705_120047358");
    },
    getDataOrderReg() {
      this.$axios.get("/api/order_reg/reg_type_list").then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.optionOrder = data.data;
        }
      });
    },
    getDataItem() {
      this.$axios.get("/api/itemtype/list").then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.optionItem = data.data;
        }
      });
    },
    handleSelectOrderType(val) {
      if (!val || val !== 1) {
        this.selectItem = "";
      }
    },
    copyUrl(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: "已成功复制到剪切板",
        type: "success",
      });
      oInput.remove();
    },
    handleSignStar(index, row) {
      if (row.sign_at) {
        return;
      }
      this.$axios.get("/api/thread/sign/" + row.thread_id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
          this.handleForSignStarMethods(row.thread_id, data.data, row, index);
          this.pageData.splice(index, 1);
          this.pageData.unshift(row);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    addShare(val) {
      this.$axios
        .get("api/expmanage/getreceivers?threadId=" + val)
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.shareOptions = data.data;
          }
        })
        .catch();
    },
    addShareC() {
      if (this.notAgin) {
        return false;
      }
      this.$axios
        .get("api/expmanage/getreceivers?threadId=" + this.nThreadId)
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            this.shareOptions = data.data;
          }
        })
        .catch();
    },
    handleForSignStarMethods(id, data, row, index) {
      for (var a = 0; a < this.pageData.length; a++) {
        if (id === this.pageData[a].thread_id) {
          this.pageData[a].sign_at = data.sign_at;
        }
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleAddAllot() {
      if (this.multipleSelection.length) {
        this.dialogVisibleClues = true;
        for (var a = 0; a < this.multipleSelection.length; a++) {
          this.allotData.ids[a] = this.multipleSelection[a].thread_id;
        }
      } else {
        this.$message.error("请先选择要转让的线索");
      }
    },
    HandleDialogVisibleClues() {
      if (!this.allotData.uid) {
        this.$message.error("请选择转让人");
        return;
      }
      this.ConversionPeople.forEach((item) => {
        if (item.id === this.allotData.uid) {
          this.allotData.username = item.username;
        }
      });
      this.$axios
        .post("/api/thread/batch_transfer", {
          params: {
            uid: this.allotData.uid,
            ids: this.allotData.ids,
            username: this.allotData.username,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success(data.msg);
            this.handelGetOrders();
            this.dialogVisibleClues = false;
            if (this.index === 0) this.prePage();
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    HandleDialogVisibleCluesClose() {
      this.dialogVisibleClues = false;
    },
    getCluesAdvisoryType() {
      this.$axios.get("/api/servertype/list").then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.serverTypes = data.data;
          for (var a = 0; a < data.data.length; a++) {
            this.GetServerTypes.push(data.data[a].server_name);
          }
        }
      });
    },
    handleMaterialSuccess(res, file) {
      if (res.code === 0) {
        this.materialFlieList.push({
          name: file.name,
          url: this.imgPath + res.data.store_result,
        });
        this.basicCluesData.files.push(this.imgPath + res.data.store_result);
        this.materialFlieListSub.push({
          uid: file.uid,
          name: file.name,
          url: res.data.store_result,
        });
      } else {
        this.$message.error(res.msg);
      }
    },
    handleMaterialPreview(file) {
      var tempwindow = window.open("_blank");
      for (var a = 0; a < this.materialFlieList.length; a++) {
        tempwindow.location = this.materialFlieList[a].url;
      }
    },
    handleMaterialRemove(file, fileList) {
      for (var i = 0; i < this.materialFlieListSub.length; i++) {
        if (file.name === this.materialFlieListSub[i].name) {
          var fileName = this.materialFlieListSub[i].url;
          this.materialFlieList.splice(i, 1);
          this.materialFlieListSub.splice(i, 1);
          this.basicCluesData.files.splice(i, 1);
        }
      }
      this.$axios.post("/api/upload/del_img", { file_name: fileName }).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    tableColumn(prop) {
      let width = "";
      if (prop === "page_title") {
        width = 140;
      }
      if (prop === "custom_phone") {
        width = 120;
      }
      if (prop === "custom_city_name") {
        width = 140;
      }
      if (prop === "wechat_account") {
        width = 140;
      }
      if (prop === "refer_cate" || prop === "group_chat_id") {
        width = 120;
      }
      return width;
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.repeat_at !== null) {
        return "success-row";
      }
      return "";
    },
    getOperationRecord(id) {
      this.$axios.get("/api/thread/operatelist/" + id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          for (var a = 0; a < data.data.length; a++) {
            this.OperationRecord.push(data.data[a]);
          }
        }
      });
    },
    groupInput(val) {
      this.highSearch.group_chat_id = val;
    },
    handleFeedbackOpen(index, row) {
      this.dialogVisible = true;
    },
    provinceCityData() {
      this.$axios.get("/api/thread/cities").then((res) => {
        const { data } = res;
        if (data.code === 0) {
          for (var a = 0; a < data.data.length; a++) {
            this.options.push(data.data[a]);
          }
        }
      });
    },
    handleClick(tab, event) { },
    pickerDataChange(val) {
      if (!val) {
        this.highSearch.start_time = "";
        this.highSearch.end_time = "";
      } else {
        this.highSearch.start_time = val[0];
        this.highSearch.end_time = val[1];
      }
    },
    pickerDataTimeChange(val) {
      if (!val) {
        this.highSearch.get_thread_at = "";
        this.highSearch.get_thread_at = "";
      } else {
        this.highSearch.get_thread_at[0] = val[0];
        this.highSearch.get_thread_at[1] = val[1];
      }
    },
    pickerDataChangeRecently(val) {
      if (!val) {
        this.highSearch.communicat_at = "";
        this.highSearch.communicat_at = "";
      } else {
        this.highSearch.communicat_at[0] = val[0];
        this.highSearch.communicat_at[1] = val[1];
      }
    },
    handleChangeSearch(value) {
      this.highSearch.custom_city_name[0] = value[0];
      this.highSearch.custom_city_name[1] = value[1];
    },
    switchChange(value) {
      this.highSearch.type = value ? 1 : 0;
    },
    switchChangeTS(value) {
      this.highSearch.is_special_industry = value ? 1 : 2;
    },
    switchChangeClues(value) {
      this.highSearch.thread_score = value ? 1 : 2;
    },
    switchChangeIsAddWx(value) {
      this.highSearch.is_add_wx = value ? 2 : 1;
    },
    switchChange2(value) {
      this.highSearch.last_communicat_at = value ? 1 : 0;
    },
    switchChangeIndustry(value) {
      this.highSearch.is_special_industry = value ? 1 : 2;
    },
    handleSearch() {
      this.pageOption.currentPage = 1;
      this.activeOpen = "";
      this.handelGetOrders(
        this.highSearch.group_chat_id,
        this.highSearch.refer_cate,
        this.highSearch.custom_city_name,
        this.highSearch.start_time,
        this.highSearch.end_time,
        this.highSearch.type,
        this.highSearch.status,
        this.highSearch.intention,
        this.highSearch.garden,
        this.highSearch.last_communicat_at,
        this.highSearch.communicat_at,
        this.highSearch.custom_sex,
        this.highSearch.custom_trait,
        this.highSearch.custom_type,
        this.highSearch.custom_industry,
        this.highSearch.custom_turnover,
        this.highSearch.custom_staff,
        this.highSearch.is_special_industry,
        this.highSearch.is_add_wx,
        this.highSearch.license,
        this.highSearch.need_combo,
        this.highSearch.maybe_need_server,
        this.highSearch.custom_source,
        this.highSearch.thread_score,
        this.highSearch.get_thread_at,
        this.highSearch.is_member
      );
    },
    handleCloseSearch() {
      this.highSearch.group_chat_id = "";
      this.highSearch.refer_cate = "";
      this.value3 = [];
      this.value = [];
      this.value1 = [];
      this.value5 = false;
      this.relation = false;
      this.highSearch.status = [];
      this.highSearch.type = 0;
      this.highSearch.intention = "";
      this.highSearch.garden = "";
      this.highSearch.last_communicat_at = 0;
      this.highSearch.communicat_at = [];
      this.highSearch.custom_sex = "";
      this.highSearch.custom_trait = [];
      this.highSearch.custom_type = [];
      this.highSearch.custom_industry = [];
      this.highSearch.custom_turnover = [];
      this.highSearch.custom_staff = [];
      this.value6 = false;
      this.highSearch.is_special_industry = "";
      this.highSearch.is_add_wx = "";
      this.highSearch.license = [];
      this.highSearch.need_combo = [];
      this.highSearch.maybe_need_server = [];
      this.highSearch.custom_source = [];
      this.highSearch.thread_score = "";
      this.highSearch.get_thread_at = [];
      this.highSearch.is_member = "";
      this.value7 = false;
      this.value8 = false;
      this.activeOpen = "";
      this.handelGetOrders(
        this.highSearch.group_chat_id,
        this.highSearch.refer_cate,
        this.value3,
        this.value,
        this.value,
        this.value5,
        this.highSearch.status,
        this.highSearch.intention,
        this.highSearch.garden,
        this.highSearch.last_communicat_at,
        this.highSearch.communicat_at,
        this.highSearch.custom_sex,
        this.highSearch.custom_trait,
        this.highSearch.custom_type,
        this.highSearch.custom_industry,
        this.highSearch.custom_turnover,
        this.highSearch.custom_staff,
        this.highSearch.is_special_industry,
        this.highSearch.is_add_wx,
        this.highSearch.license,
        this.highSearch.need_combo,
        this.highSearch.maybe_need_server,
        this.highSearch.custom_source,
        this.highSearch.thread_score,
        this.highSearch.get_thread_at
      );
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
    handleChangeHeight(val) { },
    getCluesTopHint() {
      this.$axios.get("/api/thread/remind").then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.today_communicat = data.data.today_communicat;
          this.user_thread_number = data.data.user_thread_number;
          this.repeat_count = data.data.repeat_count;
        }
      });
    },
    getVipCluesNum() { },
    vipGradeMethods(key) {
      let vipData = [" ", "青铜", "白银", "黄金", "铂金", "钻石", "最强王者"];
      return vipData[key];
    },
    vipGradeIconMethods(key) {
      let vipData = [" ", img1, img2, img3, img4, img5, img6];
      return vipData[key];
    },
    handleContactOpen(index, row) {
      this.row = row;

      setTimeout(() => {
        this.nThreadId = row.thread_id;
      }, 100);
      this.basicCluesData.index = index;
      this.basicCluesData.id = row.thread_id;
      this.basicCluesData.status = row.status;
      this.basicCluesData.custom_name = row.custom_name;
      this.basicCluesData.custom_sex = row.custom_sex;
      this.basicCluesData.custom_trait = row.custom_trait;
      this.basicCluesData.custom_type = row.custom_type;
      this.basicCluesData.is_special_industry = row.is_special_industry;
      this.basicCluesData.is_add_wx = row.is_add_wx;
      this.basicCluesData.need_combo = row.need_combo;
      this.basicCluesData.custom_staff = row.custom_staff;
      this.basicCluesData.custom_turnover = row.custom_turnover;
      this.basicCluesData.not_need_cause = row.not_need_cause;
      this.basicCluesData.maybe_need_server = row.maybe_need_server;
      this.basicCluesData.is_orther_need = row.is_orther_need;
      this.basicCluesData.remark = row.remark;
      this.basicCluesData.custom_source = row.custom_source;
      this.basicCluesData.custom_industry = row.custom_industry;
      this.basicCluesData.custom_city_name = row.custom_city_name;
      this.basicCluesData.custom_province = row.custom_province;
      this.basicCluesData.custom_city = row.custom_city;
      this.value = [row.custom_province, row.custom_city];
      this.value_city[0] = row.custom_province;
      this.value_city[1] = row.custom_city;
      this.basicCluesData.custom_phone = row.custom_phone;
      this.basicCluesData.phone_province = row.phone_province;
      this.basicCluesData.wechat_account = row.wechat_account;
      this.basicCluesData.refer_cate = row.refer_cate;
      this.basicCluesData.refer_content = row.refer_content;
      this.basicCluesData.group_chat_id = row.group_chat_id;
      this.basicCluesData.page_title = row.page_title;
      this.basicCluesData.im_name = row.im_name;
      this.basicCluesData.intention = row.intention;
      this.basicCluesData.garden = row.garden;
      this.gardenRelation = row.garden;
      this.basicCluesData.call_duration = row.call_duration;
      this.cluesIndex = index;

      if (row.status === 2) {
        this.deal = true;
      }
      this.$axios.get("api/thread/notagin?threadId=" + row.thread_id).then((res) => {
        const { data } = res;
        if (data.code === 1) {
          this.notAgin = data.data;
        }
      });
      this.addShare(row.thread_id);

      this.$axios.get("api/thread/usershare?threadId=" + row.thread_id).then((res) => {
        const { data } = res;
        if (data.code === 1) {
          this.shareSelect = data.data;
        }
      });
      this.getOperationRecord(row.thread_id);
      this.$axios.get("api/thread/communicatelist/" + row.thread_id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.activities = data.data;
          for (var a = 0; a < this.activities.length; a++) {
            if (this.activities[a].communicat_type === 1) {
              let duration =
                data.data[a].call_duration === null ? " " : data.data[a].call_duration;
              this.activities[a].communicat_type =
                "通过 " +
                this.getFeedBack(data.data[a].communicat_type) +
                "与客户沟通了" +
                duration +
                "秒";
            } else {
              this.activities[a].communicat_type =
                "通过 " +
                this.getFeedBack(data.data[a].communicat_type) +
                "与客户进行了沟通";
            }
            this.pageData[index].is_suggest = this.activities[a].tag ? 0 : 0;
            this.activities[a].size = "large";
            this.activities[a].type = "primary";
            this.activities[a].icon = "el-icon-s-custom";
            if (data.data[a].communicat_img) {
              this.activities[a].preview = data.data[a].communicat_img.split(",");
            }
          }
        } else {
          this.$message.error(data.msg);
        }
      });
      this.getCallLogs(row.custom_phone);
      this.ContactDrawer = true;
    },
    handleLinkImg(indexs, index) {
      var tempwindow = window.open("_blank");
      tempwindow.location = this.activities[index].preview[indexs];
    },
    getFeedBack(key) {
      let vipData = [
        "未知",
        "未知",
        "手机短信",
        "发送快递",
        "微信交流",
        "见面拜谈",
        "公司洽谈",
        "优开平台",
        "服务进度",
        "QQ沟通",
        "钉钉沟通",
        "未知",
        "未知",
        "未知",
        "电话沟通",
      ];
      return vipData[key];
    },
    gardenMethods(key) {
      let vipData = [" ", "上海园区", "南京园区", "徐州园区", "其他园区"];
      return vipData[key];
    },
    handelSaveChange(field, fieldName) {
      let phone = /^1[3|4|5|6|7|8|9][0-9]{9}$/;
      // if (!phone.test(val)) {
      //   this.$message.error('请输入正确的手机号')
      //   return
      // }
      let index = this.basicCluesData.index;
      if (field === "custom_phone") {
        if (
          this.basicCluesData.custom_phone.length !== 11 &&
          !phone.test(this.basicCluesData.custom_phone)
        ) {
          this.$message.error("请输入正确的手机号");
          return;
        }
      }
      if (this.basicCluesData.is_special_industry === 2) {
        this.basicCluesData.licence = "";
      }
      this.SaveChangeMethods(index, field, fieldName);
    },
    SaveChangeMethods(index, field, fieldName) {
      for (var a = 0; a < this.pageData.length; a++) {
        if (this.basicCluesData.id === this.pageData[a].thread_id) {
          if (this.pageData[a][field] === this.basicCluesData[field]) {
            return;
          }
        }
      }
      // if (this.pageData[index][field] === this.basicCluesData[field]) return
      this.$axios
        .get("/api/thread/save/" + this.basicCluesData.id, {
          params: {
            fieldName: field,
            value: this.basicCluesData[field],
            old: this.pageData[index][field],
            typeName: fieldName,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.gardenRelation = this.basicCluesData[field];
            this.handleForMethods(this.basicCluesData.id, field);
            this.OperationRecord.unshift(data.data);
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handleForMethods(id, field) {
      for (var a = 0; a < this.pageData.length; a++) {
        if (id === this.pageData[a].thread_id) {
          this.pageData[a][field] = this.basicCluesData[field];
        }
      }
    },
    handelArrangeCity(value) {
      let index = this.basicCluesData.index;
      let input = this.$refs["cascaderAddr"].getCheckedNodes()[0].pathLabels;
      this.basicCluesData.custom_city_name = input[0] + " / " + input[1];
      // this.basicCluesData.custom_province = value[0]
      // this.basicCluesData.custom_city = value[1]
      // this.value[0] = value[0]
      // this.value[1] = value[1]
      if (this.basicCluesData.custom_city_name !== "上海市 / 上海市") {
        this.$confirm("确认修改城市为其他省市吗？ 修改后该线索会消失 ", "修改所属省市", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.handelArrangeCityMethods(index, "custom_city_name", "所属省市", input);
            this.ContactDrawer = false;
          })
          .catch(() => {
            this.value = this.value_city;
            this.basicCluesData.custom_province = this.value_city[0];
            this.basicCluesData.custom_city = this.value_city[1];
          });
      }
    },
    handelArrangeCityMethods(index, field, fieldName, input) {
      for (var a = 0; a < this.pageData.length; a++) {
        if (this.basicCluesData.id === this.pageData[a].thread_id) {
          if (this.pageData[a][field] === this.basicCluesData[field]) {
            return;
          }
        }
      }
      // if (this.pageData[index].custom_province === this.basicCluesData.custom_province) return
      this.$axios
        .get("/api/thread/save/" + this.basicCluesData.id, {
          params: {
            fieldName: field,
            value: this.value[0] + "," + this.value[1] + "," + input[0] + "/" + input[1],
            old: this.pageData[index][field],
            typeName: fieldName,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.OperationRecord.unshift(data.data);
            this.handelArrangeCityMethodsFor(this.row.thread_id);
            this.$message.success(data.msg);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    handelArrangeCityMethodsFor(id) {
      for (var a = 0; a < this.pageData.length; a++) {
        if (id === this.pageData[a].thread_id) {
          this.CluesPool.splice(a, 1);
        }
      }
    },
    // loadShare () {
    //   this.$axios.get('api/thread/usershare?threadId=' + this.nThreadId).then((res) => {
    //     const { data } = res
    //     if (data.code === 1) {
    //       this.shareSelect = data.data
    //     }
    //   })
    // },
    handleShareCurrentChange(val) {
      this.nPage = val;
      this.loadShare();
    },
    handleSuccessOpen(index, row) {
      this.dialogVisible = true;
      this.row = row;
      this.index = index;
      this.getDataOrderReg();
      this.getDataItem();
    },
    searchOrderNum(val) {
      // let phone = /^1[3|4|5|6|7|8|9][0-9]{9}$/
      // if (!phone.test(val)) {
      //   this.$message.error('请输入正确的手机号')
      //   return
      // }
      this.$axios
        .get("/api/thread/get_order_numbers", {
          params: {
            custom_phone: val,
            order_reg_id: this.selectOrderType,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.searchData = true;
            this.radio = "";
            this.orderNum = data.data;
            this.$message.success("已为您查询到" + data.data.length + "个订单号");
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    HandleDialogVisible() {
      if (!this.selectOrderType) {
        this.$message.error("请选择订单类型");
        return;
      }
      if (this.selectOrderType === 5) {
        if (!this.selectItem) {
          this.$message.error("请选择单品类型");
          return;
        }
      }
      if (!this.orderNum.length) {
        this.$message.error("请输入手机号或订单号查询订单");
        return;
      }
      if (!this.radio) {
        this.$message.error("请选择你要转化的订单");
        return;
      }
      this.$axios
        .get("/api/thread/success/" + this.row.thread_id, {
          params: {
            // order_num: this.orderNum[this.orderArrayIndex].order_num,
            // assign_at: this.orderNum[this.orderArrayIndex].assign_at,
            order_id: this.radio,
            item_id: this.selectItem,
            order_reg_id: this.selectOrderType,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.$message.success("转成交成功");
            this.handleForMethods2(this.row.thread_id, data.data);
            this.clearDialogVisible();
            if (this.index === 0) this.prePage();
          } else {
            // this.clearDialogErrVisible()
            this.$message.error(data.msg);
          }
        });
    },
    doAddShare() {
      var threadId = this.nThreadId;
      var user = this.shareSelect;
      this.$axios
        .post("api/thread/addshare", {
          threadId: threadId,
          user: user,
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 1) {
            // this.shareSelect = []
            // this.$message.success(data.msg)
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch();
    },
    clearDialogErrVisible() { },
    clearDialogVisible() {
      this.dialogVisible = false;
      this.searchData = false;
      this.orderNum = "";
      this.order_num = "";
      this.item_id = "";
      this.order_reg_id = "";
      this.optionItem = "";
      this.selectOrderType = "";
    },
    handleForMethods2(id, data) {
      for (var a = 0; a < this.pageData.length; a++) {
        if (id === this.pageData[a].thread_id) {
          this.CluesPool[a].order_status = data.order_status;
          this.CluesPool[a].status = data.status;
        }
      }
    },
    prePage() {
      if (this.pageOption.currentPage === 1) return;
      this.pageOption.currentPage = this.pageOption.currentPage - 1;
    },
    HandleDialogVisibleClose() {
      this.clearDialogVisible();
    },
    handleAbandonOpen(index, row) {
      this.$confirm("确认放弃线索？ 放弃后线索将流入公海", "放弃线索", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let that = this;
          that.$axios.get("/api/thread/giveup/" + row.thread_id).then((res) => {
            const { data } = res;
            if (data.code === 0) {
              that.pageOption.total = that.CluesPool.length;
              that.$message.success("已放弃线索");
              this.handleForMethods3(row.thread_id);
              this.handelGetOrders();
            } else {
              that.$message.error(data.msg);
            }
          });
        })
        .catch(() => { });
    },
    handleForMethods3(id) {
      for (var a = 0; a < this.pageData.length; a++) {
        if (id === this.pageData[a].thread_id) {
          this.CluesPool.splice(a, 1);
        }
      }
    },
    handelGetOrders(
      groupChatId,
      referCate,
      customCityName,
      startTime,
      endTime,
      Type,
      Status,
      Intention,
      Garden,
      LastC,
      CommunicatAt,
      customSex,
      customTrait,
      customType,
      customIndustry,
      customTurnover,
      customStaff,
      isSpecialIndustry,
      isAddWx,
      license,
      needCombo,
      maybeNeedServer,
      customSource,
      threadScore,
      getThreadAt,
      isMember
    ) {
      this.$axios
        .post("/api/thread/userlist", {
          params: {
            group_chat_id: groupChatId,
            refer_cate: referCate,
            custom_city_name: customCityName,
            start_time: startTime,
            end_time: endTime,
            type: Type,
            status: Status,
            intention: Intention,
            garden: Garden,
            last_communicat_at: LastC,
            communicat_at: CommunicatAt,
            custom_sex: customSex,
            custom_trait: customTrait,
            custom_type: customType,
            custom_industry: customIndustry,
            custom_turnover: customTurnover,
            custom_staff: customStaff,
            is_special_industry: isSpecialIndustry,
            is_add_wx: isAddWx,
            license: license,
            need_combo: needCombo,
            maybe_need_server: maybeNeedServer,
            custom_source: customSource,
            thread_score: threadScore,
            get_thread_at: getThreadAt,
            is_member: isMember,
          },
        })
        .then((res) => {
          const { data } = res;
          if (data.code === 0) {
            this.lineNum = data.data.line;
            this.CluesPool = data.data.res.list;
            this.pageNodes = data.data.pageNodes;
            this.ConversionPeople = data.data.users;
            this.vipData = data.data.headered.user_get;
            this.intentionData = data.data.intention;
            this.company_allot = data.data.headered.company_allot;
            this.NVipData = data.data.headered.not_today_get;
            this.vipNum =
              data.data.headered.user_get.store_space -
              data.data.headered.user_get.user_thread_row;
            this.vipData.percentage = isFinite(
              data.data.headered.user_get.today_success /
              data.data.headered.user_get.today_get
            )
              ? (
                (data.data.headered.user_get.today_success /
                  data.data.headered.user_get.today_get) *
                100
              ).toFixed(2) + "%"
              : 0;
            this.company_allot.percentage = isFinite(
              data.data.headered.company_allot.today_success /
              data.data.headered.company_allot.today_get
            )
              ? (
                (data.data.headered.company_allot.today_success /
                  data.data.headered.company_allot.today_get) *
                100
              ).toFixed(2) + "%"
              : 0;
            this.vipName = this.vipGradeMethods(data.data.headered.user_get.level);
            this.img = this.vipGradeIconMethods(data.data.headered.user_get.level);
            this.chat_methods = data.data.chat_methods;
            this.keywordCates = data.data.keywordCates;
            this.reflects = data.data.reflects;

            for (var a = 0; a < this.CluesPool.length; a++) {
              this.CluesPool[a].refer_cate = this.refer_cateMethods(
                this.CluesPool[a].refer_cate
              );
              this.CluesPool[a].input_type = this.clientSource(
                this.CluesPool[a].input_type
              );
              this.CluesPool[a].intention = this.clientIntention(
                this.CluesPool[a].intention
              );
              this.CluesPool[a].garden = this.gardenMethods(this.CluesPool[a].garden);
            }
            this.pageOption.total = this.CluesPool.length;
          }
        })
        .finally(() => {
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("数据加载失败，请稍后再试！");
        });
    },
    clientSource(key) {
      let vipData = [" ", "IM套电", "下单未支付", "仅点快捷回复", "仅IM咨询"];
      return vipData[key];
    },
    clientIntention(key) {
      let vipData = [" ", "A", "B", "C", "D", "E"];
      return vipData[key];
    },
    refer_cateMethods(key) {
      let vipData = this.GetServerTypes;
      return vipData[key];
    },
    searchTotal() {
      return this.CluesPool.filter(
        (data) =>
          !this.search ||
          (data.custom_name &&
            data.custom_name.toLowerCase().includes(this.search.toLowerCase())) ||
          (data.custom_phone &&
            data.custom_phone.toLowerCase().includes(this.search.toLowerCase())) ||
          (data.tag_code &&
            data.tag_code.toLowerCase().includes(this.search.toLowerCase()))
      ).length;
    },
    handleSizeChange(val) {
      this.pageOption.pageSize = val;
      this.handelGetOrders(
        this.highSearch.group_chat_id,
        this.highSearch.refer_cate,
        this.highSearch.custom_city_name,
        this.highSearch.start_time,
        this.highSearch.end_time,
        this.highSearch.type,
        this.highSearch.status,
        this.highSearch.intention,
        this.highSearch.garden,
        this.highSearch.last_communicat_at,
        this.highSearch.communicat_at,
        this.highSearch.custom_sex,
        this.highSearch.custom_trait,
        this.highSearch.custom_type,
        this.highSearch.custom_industry,
        this.highSearch.custom_turnover,
        this.highSearch.custom_staff,
        this.highSearch.is_special_industry,
        this.highSearch.is_add_wx,
        this.highSearch.license,
        this.highSearch.need_combo,
        this.highSearch.maybe_need_server,
        this.highSearch.custom_source,
        this.highSearch.thread_score,
        this.highSearch.get_thread_at,
        this.highSearch.is_member
      );
    },
    handleCurrentChange(val) {
      this.pageOption.currentPage = val;
      this.handelGetOrders(
        this.highSearch.group_chat_id,
        this.highSearch.refer_cate,
        this.highSearch.custom_city_name,
        this.highSearch.start_time,
        this.highSearch.end_time,
        this.highSearch.type,
        this.highSearch.status,
        this.highSearch.intention,
        this.highSearch.garden,
        this.highSearch.last_communicat_at,
        this.highSearch.communicat_at,
        this.highSearch.custom_sex,
        this.highSearch.custom_trait,
        this.highSearch.custom_type,
        this.highSearch.custom_industry,
        this.highSearch.custom_turnover,
        this.highSearch.custom_staff,
        this.highSearch.is_special_industry,
        this.highSearch.is_add_wx,
        this.highSearch.license,
        this.highSearch.need_combo,
        this.highSearch.maybe_need_server,
        this.highSearch.custom_source,
        this.highSearch.thread_score,
        this.highSearch.get_thread_at,
        this.highSearch.is_member
      );
    },
    handelSetValue() {
      for (var i = 0; i <= this.col.length; i++) {
        this.value1.push(i);
      }
    },
    handelDownload() {
      window.location.href = "http://wx.qyh.com/api/admin/tyc_order/download";
    },
    handleLogOpen(id) {
      this.$axios.get("/api/admin/tyc_orders/log/" + id).then((res) => {
        const { data } = res;
        if (data.code === 0) {
          this.logs = data.data;
          this.logDrawer = true;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    handleAddOpen() {
      this.addDrawer = true;
    },
    handleAddDrawerBeforeClose(done) {
      this.$confirm("确认关闭?")
        .then((_) => {
          this.clearAddData();
          this.clearDialogVisible();
          done();
        })
        .catch((_) => { });
    },
    handleAddDrawerClose() {
      this.ContactDrawer = false;
      this.clearAddData();
    },
    clearAddData() {
      this.addForm.client_intention = "";
      this.addForm.communication_note = "";
      this.addForm.status = 1;
      this.addForm.custom_name = "";
      this.addForm.custom_phone = "";
      this.addForm.corporate_name = "";
      this.addForm.corporate_phone = "";
      this.addForm.refer_cate = "";
      this.addForm.refer_content = "";
      this.materialFlieListSub = [];
      this.materialFlieList = [];
      this.basicCluesData.files = [];
      this.OperationRecord = [];
    },
    handleUpdateClose(done) {
      this.$confirm("确认关闭?")
        .then((_) => {
          this.clearUpdateData();
          done();
        })
        .catch((_) => { });
    },
    clearUpdateData() {
      this.saveForm.page_title = "";
      this.saveForm.group_chat_id = "";
      this.saveForm.location = "";
      this.saveForm.age = null;
      this.saveForm.reason_for_loss = "";
      this.saveForm.refund = "否";
      this.saveForm.reason_for_return = "";
      this.saveForm.reason_for_return_info = "";
      this.saveForm.refund_date = "";
      this.saveForm.proxy_demand = "否";
      this.saveForm.not_proxy_reason = "";
      this.saveForm.consultant = "";
      this.saveForm.ind_land_city = "";
    },
    handleConductClose(done) {
      this.$confirm("确认关闭?")
        .then((_) => {
          this.clearConductData();
          done();
        })
        .catch((_) => { });
    },
    clearConductData() {
      this.conductForm.index = null;
      this.conductForm.id = 0;
      this.conductForm.organizer = "";
      this.conductForm.organizer_at = "";
      this.conductForm.verifier = "";
      this.conductForm.verifier_at = "";
      this.conductForm.company = "";
      this.conductForm.declarer = "";
      this.conductForm.declare_at = "";
    },
    handleSelChange(field, fieldName) {
      this.handleConductChange(field, fieldName);
    },
    handelPickerChange(field, fieldName) {
      this.handleConductChange(field, fieldName);
    },
    LastWeek() {
      const end = new Date();
      const start = new Date();
      const lastWeek = new Date().getDay(); // 获取今日周几
      // 开始时间(上周一与今天间隔的天数)
      start.setTime(start.getTime() - 3600 * 1000 * 24 * (7 + lastWeek - 1)); // 减1是因为以下时间戳操作,例如周二,但是时间戳还在周一后的xx小时
      // 结束时间(上周末与今天间隔的天数)
      end.setTime(end.getTime() - 3600 * 1000 * 24 * lastWeek);
      return [start, end];
    },
    thisWeek() {
      var Nowdate = new Date();
      var WeekFirstDay = new Date(Nowdate - (Nowdate.getDay() - 1) * 86400000);

      var M = Number(WeekFirstDay.getMonth()) + 1;
      var start = WeekFirstDay.getFullYear() + "-" + M + "-" + WeekFirstDay.getDate();

      var WeekLastDay = new Date((WeekFirstDay / 1000 + 6 * 86400) * 1000);
      var Mon = Number(WeekLastDay.getMonth()) + 1;
      var end = WeekLastDay.getFullYear() + "-" + Mon + "-" + WeekLastDay.getDate();

      return [start, end];
    },
    thisMonth() {
      const end = new Date();
      const start = new Date();
      // 方法1
      const endDay = new Date().getDate() - 1; // 获取今日几号,减1是因为以下时间戳操作,例如今日16号,但是时间戳还在15号后的xx小时
      start.setTime(start.getTime() - 3600 * 1000 * 24 * endDay);
      // 方法2
      // start.setDate(1) //setDate(1)表示设置开始时间为本月1号,此办法同样可以实现
      return [start, end];
    },
    LastMonth() {
      const end = new Date();
      const start = new Date();
      const year = new Date().getFullYear(); // 获取年份
      let month = new Date().getMonth(); // 获取月份
      month = month === 0 ? 1 : month; // 特殊处理:如果为1月 则下方取1月的天数
      const febDays = year % 4 ? 29 : 28; // 判断今年是否为闰年,如是则二月天数为29天,反之为28天
      let days = [31, febDays, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // 罗列12个月的天数
      start.setDate(1 - days[month - 1]); // setDate(1)表表示设置为本月1号,故 本月1号 - 上月天数 = 上月1号
      end.setDate(1 - 1); // 以此得出,本月1号 - 1天 = 上月最后一天
      return [start, end];
    },
    call(num) {
      window.CallClient.call({ calleeNumber: num, calleeName: num });
    },
    call2(index, row) {
      // this.$axios.post("/api/admin/call_logs/" + row.custom_phone).then((res) => {
      this.$axios
        .post("api/admin/call_logs_call", {
          phone: row.vagary_phone ? row.vagary_phone: row.custom_phone,
        })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.$message.success("调用成功，请注意接听来电");
            this.activeName = "calls";
            this.handleContactOpen(index, row);
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    getCallLogs(phone) {
      this.$axios
        .post(
          "/api/admin/tycOrders/call_logs?page=" + this.callPageOption.currentPage,
          { phone: phone },
          { loadingClose: true }
        )
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.callPageData = data.data.data;
            this.callPageOption.total = data.data.total;
          }
        });
    },
    handleCallCurrentChange(val) {
      this.callPageOption.currentPage = val;
      this.getCallLogs(this.row.custom_phone);
    },
    handelcall(num) {
      if (!num) {
        this.$message.error("手机号为空");
        return;
      }

      this.$axios.post("/api/admin/call_logs/" + num).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.$message.success("调用成功，请注意接听来电");
          setTimeout(this.getCallLogs(this.row.custom_phone), 500);
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    submitRemark(id, index) {
      this.remarkFrom.id = id;
      this.remarkFrom.index = index;
      this.remarkVisible = true;
    },
    clearRemarkFrom() {
      this.remarkFrom.id = null;
      this.remarkFrom.index = null;
      this.remarkFrom.remark = "";
    },
    handleRemarkClose(done) {
      this.clearRemarkFrom();
      done();
    },
    handelRemarkSubmit() {
      if (!(this.remarkFrom.id && this.remarkFrom.index !== null)) {
        this.$message.error("请求错误，清刷新重试");
        return;
      }

      if (!this.remarkFrom.remark) {
        this.$message.error("内容不能为空");
        return;
      }

      this.$axios
        .post("/api/admin/callLogs/remark", {
          id: this.remarkFrom.id,
          remark: this.remarkFrom.remark,
          type: "clue",
          typeId: this.row.thread_id,
        })
        .then((res) => {
          let { data } = res;
          if (data.code === 0) {
            this.callPageData[this.remarkFrom.index].remark = this.remarkFrom.remark;
            this.pageData[this.cluesIndex].last_communicat_at =
              data.data.lastCommunicatAt;
            this.pageData[this.cluesIndex].communicat_times = data.data.communicatTimes;
            this.pageData[this.cluesIndex].call_duration = data.data.billsec;
            this.clearRemarkFrom();
            this.remarkVisible = false;
            this.$message.success(data.msg);
          }
        });
    },
    play(isStorage, url) {
      if (!url) {
        this.$message.error("录音为空");
        return;
      }

      if (!isStorage) {
        window.open(url);
        return;
      }

      this.$axios.post("/api/admin/callLogs/getObject", { filePath: url }).then((res) => {
        let { data } = res;
        if (data.code === 0) {
          this.dialogPlayVisible = true;
          this.waveSurferInit(data.data);
        }
      });
    },
    waveSurferInit(src) {
      this.$nextTick(() => {
        this.wavesurfer = WaveSurfer.create({
          container: this.$refs.waveform,
          barWidth: 1,
          cursorColor: "black",
          progressColor: "blue",
          backend: "MediaElement",
          audioRate: "1",
          plugins: [
            Timeline.create({
              container: "#wave-timeline",
            }),
          ],
        });
        this.wavesurfer.load(src);
        let that = this;
        this.wavesurfer.on("finish", function () {
          that.isPlay = false;
        });
      });
    },
    playMusic() {
      this.wavesurfer.playPause.bind(this.wavesurfer)();
      this.isPlay = this.wavesurfer.isPlaying();
    },
    dialogPlayVisibleBeforeClose(done) {
      this.isPlay = false;
      this.wavesurfer.destroy();
      done();
    },
    handleLicensePreview(file) { },
    handleLicenseChange(file, fileList) {
      this.licenseList = fileList;
    },
    handleLicenseRemove(file, fileList) {
      this.licenseList = fileList;
      this.formData = null;
      this.formData = new FormData();
      this.licenseList.forEach((file) => this.formData.append("file[]", file.raw));
      for (let key in this.addPicForm) {
        this.formData.append(key, this.addPicForm[key]);
      }
    },
    handleParse(e) {
      let file = null;
      if (
        e.clipboardData &&
        e.clipboardData.items[0] &&
        e.clipboardData.items[0].type &&
        e.clipboardData.items[0].type.indexOf("image") > -1
      ) {
        file = e.clipboardData.items[0].getAsFile();
        let reader = new FileReader();
        reader.readAsDataURL(file);
        let that = this;
        reader.onload = function (e) {
          let fileObj = {
            name: file.name,
            percentage: 0,
            raw: file,
            size: file.size,
            status: "ready",
            url: e.target.result,
          };

          if (that.licenseList.length < 5) {
            that.licenseList.push(fileObj);
          } else {
            that.$message.error("最多可以上传5张");
          }
        };
      } else {
        this.$message.warning("上传的文件必须为图片");
      }
    },
    handleSave(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.addPicForm.communicat_type) {
            this.$message.error("请选择联系方式");
            return;
          }
          if (!this.addPicForm.intention) {
            this.$message.error("请选择客户意向");
            return;
          }
          if (!this.addPicForm.keyword_cate) {
            this.$message.error("请选择关键词分类");
            return;
          }

          if (this.addPicForm.keyword.length <= 0) {
            this.$message.error("请选择关键词");
            return;
          }
          if (!this.addPicForm.has_contacted) {
            this.$message.error("请选择是否与客户取得联系");
            return;
          }
          if (this.addPicForm.is_notice === "1" && !this.addPicForm.next_contact_time) {
            this.$message.error("请选择下次沟通的时间");
            return;
          }
          if (!this.addPicForm.communication_note) {
            this.$message.error("沟通内容不能为空");
            return;
          }
          this.formData = new FormData();
          this.licenseList.forEach((file) => this.formData.append("file[]", file.raw));
          for (let key in this.addPicForm) {
            this.formData.append(key, this.addPicForm[key]);
          }
          this.$axios
            .post("/api/thread/communicate/" + this.basicCluesData.id, this.formData)
            .then((res) => {
              const { data } = res;
              if (data.code === 0) {
                data.data.size = "large";
                data.data.type = "primary";
                data.data.icon = "el-icon-s-custom";
                this.getCluesTopHint();

                this.CluesPool[this.cluesIndex].communicat_times =
                  data.data.communicat_times;
                this.CluesPool[this.cluesIndex].intention = this.clientIntention(
                  data.data.intention
                );
                this.CluesPool[this.cluesIndex].call_duration = data.data.call_duration;
                this.CluesPool[this.cluesIndex].garden = this.gardenMethods(
                  data.data.garden
                );
                if (data.data.communicat_type === 1) {
                  data.data.communicat_type =
                    "通过 " +
                    this.getFeedBack(data.data.communicat_type) +
                    "与客户沟通了" +
                    data.data.call_duration +
                    "秒";
                } else {
                  data.data.communicat_type =
                    "通过 " +
                    this.getFeedBack(data.data.communicat_type) +
                    "与客户进行了沟通";
                }
                if (data.data.communicat_img) {
                  data.data.preview = data.data.communicat_img.split(",");
                }
                this.activities.unshift(data.data);
                this.handleAddDrawerClose();
                this.$message.success(data.msg);
                this.formData = null;
                this.licenseList = [];
                this.addPicForm.communicat_type = null;
                this.addPicForm.communication_note = "";
                this.addPicForm.intention = null;
                this.keyword_cate = null;
                this.keyword = [];
                this.has_contacted = null;
                this.is_notice = "0";
                this.next_contact_time = null;
              } else {
                this.$message.error(data.msg);
              }
            });
        }
      });
    },
    handleClickCollapseOutSide(event) {
      const elCollapse = this.$el.querySelector('.el-collapse');
      if (elCollapse && !elCollapse.contains(event.target)) {
        this.activeOpen = '';
      }
    },
    filterOptions(node, keyword) {
      return filterKeywordOptions(node, keyword);
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickCollapseOutSide);
  },
  mounted() {
    this.getCluesAdvisoryType();
    this.provinceCityData();
    this.getCluesTopHint();
    this.handelGetOrders();
    this.getCluesType();
    document.addEventListener('click', this.handleClickCollapseOutSide);
  },
};
</script>

<style scoped>
.public {
  display: flex;
  width: 100%;
  box-sizing: border-box;
}

.clues {
  padding: 1.42rem 0.4rem 0.4rem 0.4rem;
  max-height: 100vh;
}

.clues .header-style {
  z-index: 2;
  height: 214px !important;
  padding: 0px !important;
}

.clues .main-style {
  z-index: 1;
  padding: 0px !important;
  overflow-y: auto;
}

.clues .footer-style {
  text-align: right;
}

.clues .footer-style .el-pagination {
  padding-top: 20px;
}

.clues .popover_span .el-position {
  font-family: Arial, "Microsoft Yahei", "Helvetica Neue", Helvetica, sans-serif;
}

.clues .count_style {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.clues .icon-qingtonghuiyuan {
  color: #E9935D;
}

.clues .icon-baiyinhuiyuan {
  color: #E6E8FA;
}

.clues .icon-huangjinhuiyuan {
  color: #FFD32F;
}

.clues .icon-qingtong {
  color: #40BBEC;
}

.clues .icon-zuanshi {
  color: #83A4FF;
}

.clues .icon-wangzhe {
  color: #A8A8A8;
}

.clues .el-icon-chat-dot-square {
  color: #88D023;
}

.el-drawer__wrapper>>>.el-drawer__header span {
  color: #4c87fc;
  font-size: 0.36rem;
  font-weight: 400;
}

.el-drawer__wrapper>>>.el-timeline-item__wrapper {
  top: 0;
}

.top_hint {
  height: 0.8rem;
  line-height: 0.8rem;
  background: #ECF4FF;
}

.top_hint span {
  color: #5787FF;
}

.mb-10 {
  margin-bottom: 0.2rem;
  margin-top: 0.4rem;
}

.mt-10 {
  margin-top: 0.2rem;
}

.mt-40 {
  margin-top: 1rem;
}

.level {
  display: flex;
  align-items: center;
  position: relative;
  padding-right: 0.32rem;
}

.level img {
  width: 0.32rem;
  height: 0.30rem;
}

.level .el-icon-question {
  margin-left: 0.1rem;
  color: #409EFF;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.count {
  padding-left: 0.2rem;
  line-height: 0.56rem;
}

.tr {
  text-align: right;
}

.popoverList {
  height: auto;
  overflow-y: auto;
  padding-top: 0.2rem;
  padding-left: 0.2rem;
  box-sizing: border-box;
}

.popoverList .time_right {
  width: 100%;
  margin-top: 0.4rem;
  overflow: hidden;
  word-break: break-all;
  white-space: normal;
}

.m-tabs-content {
  overflow-y: auto;
}

.m-tabs-content .listClues {
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 0.4rem;
}

.m-tabs-content .listClues .counts {
  display: inherit;
  width: 25%;
  line-height: 0.56rem;
  margin-right: 0.2rem;
  color: #000;
}

.m-tabs-content .listClues .listCluesTitle {
  font-weight: bold;
}

.m-tabs-content .tabs_line {
  display: flex;
}

.m-tabs-content .tabs_line .lines {
  width: 0.06rem;
  height: 0.30rem;
  background: #4C87FC;
  margin-right: 0.1rem;
}

.m-tabs-content .tabs_line .tabs-title {
  color: #000000;
  font-weight: bold;
}

.m-tabs-content .tabs-title-color {
  color: #4C87FC;
  height: 0.8rem;
  line-height: 0.8rem;
  border-bottom: 1px solid #E2E2E2;
  margin-bottom: 0.6rem;
}

.m-tabs-content .m-label {
  line-height: 0.64rem;
}

.m-tabs-content .text_right {
  text-align: left;
}

.m-tabs-content .el-row {
  margin-bottom: 0.4rem;
}

.m-tabs-content .el-date-editor.el-input,
.m-tabs-content .el-date-editor.el-input__inner {
  width: 100%;
}

.el-select,
.el-cascader {
  width: 100%;
}

.bottom-btn {
  padding: .2rem;
  text-align: right;
}

.clues>>>.el-table__header th {
  color: #333333;
  background-color: #ECF4FF;
}

.popovers span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.elRadioGroup>>>.el-radio-button .el-radio-button__inner {
  border: 1px solid #dcdfe6;
  border-radius: 0.08rem;
  margin: 0 0.1rem 0.1rem 0;
  box-sizing: border-box;
}

.elRadioGroup>>>.el-radio-button__orig-radio:checked+.el-radio-button__inner {
  box-shadow: 0 0 transparent;
}

.el-position {
  position: relative;
}

.el-position .dot {
  display: inline-block;
  width: 0.1rem;
  height: 0.1rem;
  border-radius: 50%;
  margin-right: 0.1rem;
  position: absolute;
  top: 0;
  left: -0.2rem;
  bottom: 0;
  margin: auto;
}

.history_feedback {
  display: flex;
  align-items: center;
}

.history_feedback .line {
  width: 0.06rem;
  height: 0.30rem;
  background: #4C87FC;
  margin-right: 0.1rem;
}

.history_feedback span {
  color: #424242;
  font-size: 0.30rem;
}

.block {
  height: auto;
  overflow-y: auto;
  padding-top: 0.2rem;
  padding-left: 0.2rem;
  box-sizing: border-box;
}

.block .m_comment {
  padding: 0.2rem 0.4rem;
  flex-direction: column;
  margin-bottom: 0.2rem;
  background: #f3f3f3;
  height: auto;
  border-radius: 0.09rem;
}

.block .m_comment .comment_name_time {
  margin-bottom: 0.4rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  line-height: 0.5rem;
}

.block .m_comment .comment_name_time span {
  color: rgb(102, 102, 102);
}

.block .time_right {
  width: 100%;
  margin-top: 0.4rem;
  overflow: hidden;
  word-break: break-all;
  white-space: normal;
}

.block .handleLinkImg {
  margin-right: 0.2rem;
}

.block .handleLinkImg:nth-last-child(1) {
  margin-right: 0;
}

.el-timeline-item__node--large {
  width: 0.4rem;
  height: 0.4rem;
}

::-webkit-scrollbar {
  width: 0.1rem;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  background: #cdcdcd;
  border-radius: 5px;
}

::-webkit-scrollbar-track {
  background: #f8f8f8;
  border-radius: 5px;
}

.good {
  webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.12);
}

.contents {
  margin-bottom: 0.4rem;
}

.contents .radios .is-bordered {
  margin-bottom: 0.2rem;
  margin-left: 0;
}

.contents .tables {
  width: 100%;
  display: flex;
  height: 0.88rem;
  align-items: center;
  box-sizing: border-box;
  border-bottom: 1px solid #EBEEF5;
  padding: 0 0.2rem;
}

.contents .tables .spans {
  color: #333;
  font-weight: bold;
}

.contents .tables:nth-last-child(1) {
  border-bottom: 0;
}

.dialog-footer {
  display: block;
  position: absolute;
  right: 0.4rem;
  bottom: 0.2rem;
}

.changeHeight {
  padding: 0.2rem;
  margin-top: 0.4rem;
}

.el-collapse {
  border-bottom: 0;
  border-top: 0;
}

.el-collapse>>>.el-collapse-item__header {
  color: #4C87FC;
  font-weight: bold;
}

.el-collapse>>>.el-collapse-item__arrow {
  color: #4C87FC;
}

.el-collapse>>>.el-collapse-item__content {
  padding-bottom: 0;
}

.el_dialogs>>>.el-dialog__body {
  padding-left: 0;
  padding-right: 0;
}

.el_dialogs>>>.el-dialog__header {
  padding: 0;
}

.box_title {
  margin-bottom: 0.4rem;
  padding-left: 0.6rem;
}

.box_title span {
  font-size: 0.32rem;
  color: #333;
  font-weight: bold;
}

.dialog_box {
  padding-left: 1.45rem;
  padding-right: 1.45rem;
}

.dialog_box .box_p {
  font-size: 0.28rem;
  line-height: 0.7rem;
  color: #666666;
}

.dialog_box img {
  width: 100%;
  margin-top: 0.4rem;
}

.el-date-editor {
  width: 100% !important;
}

.dialog_img {
  text-align: center;
}

.dialog_img img {
  width: 90%;
  height: 90%;
}

.text-c {
  text-align: center;
}

.loading-placeholder {
  text-align: center;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/clues/clues.vue